{
  "account.account": "プロフィールとセキュリティ",
  "account.accountDeleted": "アカウントは正常に削除されました。",
  "account.accountDescription": "名前、パスワード、アカウント削除",
  "account.accountSection": "アカウント",
  "account.changeEmail": "メールアドレスを変更",
  "account.changePassword": "パスワードを変更する",
  "account.currentPassword": "現在のパスワード",
  "account.dangerZone": "危険な操作",
  "account.deleteAccount": "アカウントを削除する",
  "account.deleteAccountConfirmation": "アカウントを削除してもよろしいですか?この操作は元に戻すことができません。",
  "account.deleteAccountDescription": "この操作により、アカウントとすべての情報が削除されます。もう後戻りはできません。",
  "account.emailChange": "メールアドレスの変更",
  "account.emailChangeConfirmation": "メールアドレス変更の確認",
  "account.emailChangeFailure": "メールアドレス変更リンクが無効か期限切れです。",
  "account.emailChangeIntro": "新しいメールアドレスと現在のパスワードを入力してください。新しいアドレスにリンクを送信します。メールアドレスは、そのリンクを開いた時点で変更されます。",
  "account.emailChangeNeedsPassword": "メールアドレスを変更するには、まずパスワードを設定してください。設定用のリンクをメールでお送りします。ログインしたままご利用いただけます。",
  "account.emailChangeSetPasswordFirst": "メールアドレスを変更するには、まずパスワードを設定してください。",
  "account.emailChangeSuccess": "メールアドレスが {newEmail} に正常に変更されました。",
  "account.emailChangeSuccessNoAddress": "メールアドレスが正常に変更されました。",
  "account.emailChangeVerificationSent": "新しいメールアドレスに確認メールが送信されました。受信トレイを確認し、リンクをクリックして変更を確認してください。",
  "account.manageAccount": "アカウントの管理",
  "account.newEmailAddress": "新しいメールアドレス",
  "account.newPassword": "新しいパスワード",
  "account.newPasswordAgain": "新しいパスワードを再入力",
  "account.noPasswordExplanation": "Google、Apple、またはFacebookでログインしているため、アカウントにはまだSmartMixinのパスワードがありません。パスワードを設定するためのリンクをメールでお送りします。ログインしたままご利用いただけます。",
  "account.oldPassword": "以前のパスワード",
  "account.passwordChange": "パスワードの変更",
  "account.passwordChangeDescription": "アカウントを安全に保ちます",
  "account.passwordUpdated": "パスワードが正常に更新されました。",
  "account.profile": "プロフィール",
  "account.profileUpdated": "プロフィールが正常に更新されました。",
  "account.reauthAccountMismatchApple": "そのApple AccountはSmartMixinにリンクされているアカウントではありません。ログインに使用しているApple Accountで、もう一度お試しください。",
  "account.reauthAccountMismatchGoogle": "そのGoogleアカウントはSmartMixinにリンクされているアカウントではありません。ログインに使用しているGoogleアカウントを選んで、もう一度お試しください。",
  "account.reauthAccountMismatchGoogleNamed": "そのGoogleアカウントはSmartMixinにリンクされているアカウントではありません。{email} を選んで、もう一度お試しください。",
  "account.reauthConfirmBody": "メールアドレスを変更するには、ログインに使用しているアカウントで確認してください。",
  "account.reauthConfirmed": "{provider}で確認済み",
  "account.reauthConfirmTitle": "ご本人確認",
  "account.reauthExpired": "確認の有効期限が切れました。続けるには、もう一度確認してください。",
  "account.reauthFailed": "ご本人確認ができませんでした。もう一度お試しください。",
  "account.reauthPopupBlocked": "ブラウザがAppleのウィンドウをブロックしました。もう一度ボタンを押してください。",
  "account.reauthProviderUnavailable": "現在{provider}が応答していません。数分後にもう一度お試しください。",
  "account.reauthSetPasswordInstead": "代わりにパスワードを設定",
  "account.reauthThrottled": "短時間に何度も確認を試みました。しばらくしてからお試しください。",
  "account.sendSetPasswordLink": "リンクをメールで送信",
  "account.sendSetPasswordLinkLong": "パスワード設定用のリンクをメールで送信",
  "account.setPassword": "パスワードを設定",
  "account.setPasswordDescription": "アカウントにはまだパスワードがありません",
  "account.setPasswordFirst": "先にパスワードを設定",
  "account.setPasswordLinkError": "リンクを送信できませんでした。接続を確認して、もう一度お試しください。",
  "account.setPasswordLinkRateLimited": "短時間に何度もリンクをリクエストしました。受信トレイと迷惑メールフォルダで最新のリンクを確認するか、しばらくしてからお試しください。",
  "account.setPasswordLinkResend": "もう一度送信",
  "account.setPasswordLinkRetry": "再試行",
  "account.setPasswordLinkSent": "{email} にリンクを送信しました。リンクを開いてパスワードを設定してから、この画面に戻ってください。",
  "account.signedInAs": "ログイン中のアカウント",
  "account.updateYourProfile": "プロフィールを更新する",
  "account.updateYourProfileDescription": "名前と表示設定",
  "addons.accountOnHold": "アカウントの接続が期限切れになりました。データ更新を再開するには再接続してください。",
  "addons.accountOnHoldTitle": "アカウント停止中",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "このリンクから API キーを作成および取得します",
  "addons.ambientWeatherDescription": "Ambient Weather 気象観測所 (WS-5000、WS-2000、WS-2902C など)",
  "addons.apiKey": "APIキー",
  "addons.applicationKey": "アプリケーションキー",
  "addons.availableServices": "利用可能",
  "addons.cannotDisconnectLastAccount": "唯一のログイン方法を切断することはできません。まず別のログイン方法を追加してください。",
  "addons.connect": "接続",
  "addons.connected": "接続済み",
  "addons.connectedAccounts": "接続済みアカウント",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "接続済みアカウントを読み込んでいます…",
  "addons.connectedServices": "接続済み",
  "addons.connectedSince": "{date}から接続",
  "addons.connectionSection": "接続",
  "addons.connectionSuccess": "{provider}アカウントが正常に接続されました",
  "addons.davisApiSecret": "APIシークレット",
  "addons.davisApiV2Key": "V2 API キー",
  "addons.davisDescription": "Davis 気象観測所 (Vantage Vue、Vantage Pro2 など)",
  "addons.davisRetrieveApiKey": "このリンクから V2 API キーを取得します",
  "addons.disconnect": "切断",
  "addons.disconnectConfirmation": "{provider}アカウントを切断してもよろしいですか？",
  "addons.disconnectEnergyConfirmation": "SmartMixin は Netatmo Energy との同期を停止し、SmartMixin から家を削除します。Netatmo アカウントとデバイスには影響しません。",
  "addons.disconnectEnergyDescription": "同期を停止し、SmartMixin から家を削除します。",
  "addons.disconnectionSuccess": "{provider}アカウントが正常に切断されました",
  "addons.disconnectProviderDescription": "同期を停止し、このサービスの観測所とその履歴を削除します。",
  "addons.disconnectServiceConfirmation": "SmartMixin は {provider} との同期を停止し、このサービスの観測所とそのすべての履歴を削除します。{provider} のアカウント自体には影響しません。",
  "addons.disconnectServiceTitle": "{provider}を切断しますか？",
  "addons.ecowittCreateAndRetrieveKeys": "このリンクから API キーとアプリケーション キーの両方を作成および取得します",
  "addons.ecowittDescription": "Ecowitt は、プロ仕様の Wi-Fi 気象ステーション、ワイヤレス屋内屋外温度計、湿度モニター、高精度雨量計、大気質モニターなどを提供しています。",
  "addons.helpLink": "{provider}の接続方法",
  "addons.integrationsSection": "連携",
  "addons.myAcuriteAccountOnHold": "あなたのアカウントは保留されました。アカウントを再接続するにはパスワードを入力してください",
  "addons.myAcuriteDescription": "AcuRite は、北米でナンバー 1 の気象観測所ブランドです。時間、温度、気象テクノロジーのリーダーとして、AcuRite は屋内と屋外の環境に関する詳細な情報を提供するため、自信を持って 1 日の計画を立てることができます。",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Netatmo サーモスタットを使用して、ベッドから、または世界の裏側から家の温度を変更します。",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "自宅の個人気象観測所",
  "addons.notConnected": "未接続",
  "addons.or": "または",
  "addons.providerAccountDisconnected": "気象サービスへの接続が期限切れになりました。データ更新を再開するには再接続してください。",
  "addons.reconnect": "再接続",
  "addons.socialConnectionsIntro": "ソーシャルアカウントをリンクして素早くログインできます。いつでもアカウントを接続または切断できます。",
  "addons.weatherflowAccessToken": "アクセストークン",
  "addons.weatherflowCreateToken": "このリンクからトークンを作成して取得します",
  "addons.weatherflowTempestDescription": "風速計と雨量計を内蔵した Tempest 気象システム",
  "addons.weatherServices": "気象サービス",
  "addons.weatherServicesConnected": "{count, plural, =0 {接続されているサービスはありません} other {#件のサービスが接続されています}}",
  "addons.weatherServicesDescription": "Netatmo、Davis、Weatherflowなどを接続",
  "addons.wundergroundApiKey": "APIキー",
  "addons.wundergroundDescription": "Weather Underground は、気象観測所や大気質モニターなどの環境センサーからのデータを接続する人々のグローバル コミュニティです。これにより、情熱を高めるために必要なリッチでハイパーローカルなデータを提供できます。",
  "addons.wundergroundRemoveStationDescription": "ステーションはSmartMixinアカウントから外れます。他のSmartMixinアカウントも追加していない限り、ステーションとSmartMixinが記録した履歴は削除されます。Weather Underground上では何も変わりません。",
  "addons.wundergroundRemoveStationTitle": "{station} を削除しますか？",
  "addons.wundergroundRetrieveApiKey": "このリンクから API キーを取得します",
  "addons.wundergroundStationId": "ステーションID",
  "airQuality.adviceActivityGood": "屋外で体を動かすのに最適な日です",
  "airQuality.adviceActivityHazardous": "屋外でのすべての身体活動を避けてください",
  "airQuality.adviceActivityLabel": "屋外での運動",
  "airQuality.adviceActivityModerate": "屋外で体を動かすのに良い日です",
  "airQuality.adviceActivitySensitive": "屋外での活動は短時間・低強度にすることを検討してください",
  "airQuality.adviceActivityUnhealthy": "長時間または激しい活動を控え、休憩を多めに取ってください",
  "airQuality.adviceActivityVeryUnhealthy": "長時間または激しい活動は避け、屋内への変更を検討してください",
  "airQuality.adviceGroupsGood": "特別な対策は必要ありません",
  "airQuality.adviceGroupsHazardous": "屋内にとどまり、活動量を控えめにしてください",
  "airQuality.adviceGroupsLabel": "感受性の高い方",
  "airQuality.adviceGroupsModerate": "特に敏感な方：活動は短時間・低強度にしてください",
  "airQuality.adviceGroupsSensitive": "屋外での活動は短時間・低強度にし、休憩を多めに取ってください",
  "airQuality.adviceGroupsUnhealthy": "長時間または激しい屋外活動は避け、屋内への変更を検討してください",
  "airQuality.adviceGroupsVeryUnhealthy": "屋外でのすべての身体活動を避け、延期するか屋内に変更してください",
  "airQuality.adviceTimingLabel": "外出する時間帯",
  "airQuality.adviceTimingMorning": "午前中がおすすめです。オゾン濃度が低い時間帯です",
  "airQuality.airQuality": "空気の質",
  "airQuality.airQualityIndex": "大気質指数",
  "airQuality.aqiForecast": "大気質予報",
  "airQuality.co2Fresh": "新鮮",
  "airQuality.co2GettingStale": "ややこもっている",
  "airQuality.co2Stale": "こもっている",
  "airQuality.dailyForecast": "日別予報",
  "airQuality.dominantPollutant": "主要汚染物質",
  "airQuality.expectedPeak": "予想ピーク",
  "airQuality.expectedPeakAt": "予想ピーク {value} · {band} · {time}",
  "airQuality.good": "良い",
  "airQuality.goodDescription": "大気の質は満足のいくものであると考えられており、大気汚染によるリスクはほとんど、またはまったくありません。",
  "airQuality.hazardous": "危険",
  "airQuality.hazardousDescription": "健康に関する警告: 誰でもより深刻な健康影響を経験する可能性があります",
  "airQuality.indoorAirQuality": "室内空気の質",
  "airQuality.moderate": "普通",
  "airQuality.moderateDescription": "空気の質は許容範囲内です。ただし、一部の汚染物質については、大気汚染に異常に敏感なごく少数の人々にとって、中程度の健康上の懸念がある可能性があります。",
  "airQuality.noForecastForLocation": "この地点の大気質予報は利用できません。",
  "airQuality.now": "現在",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "汚染物質",
  "airQuality.recommendations": "推奨事項",
  "airQuality.sensitiveUnhealthy": "敏感な人々にとって不健康",
  "airQuality.sensitiveUnhealthyDescription": "敏感なグループのメンバーは健康への影響を経験する可能性があります。一般人への影響は考えられません。",
  "airQuality.subIndex": "AQIサブインデックス",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "指数について",
  "airQuality.unhealthy": "不健康",
  "airQuality.unhealthyDescription": "誰もが健康への影響を経験し始める可能性があります。敏感なグループのメンバーは、より深刻な健康影響を経験する可能性があります",
  "airQuality.veryUnhealthy": "非常に不健康",
  "airQuality.veryUnhealthyDescription": "緊急事態に関する健康上の警告。人口全体が影響を受ける可能性が高くなります。",
  "alerts.addAlert": "アラートを追加",
  "alerts.addCondition": "条件の追加",
  "alerts.alertAdded": "アラートが正常に追加されました",
  "alerts.alertAuthorizationNotice": "アラートは、SmartMixin に通知の表示を許可した場合にのみ機能します。",
  "alerts.alertDeleted": "アラートは正常に削除されました",
  "alerts.alertName": "アラート名",
  "alerts.alertWhen": "次の場合に警告を受け取りたいです。",
  "alerts.aqiGreaterThan": "AQI が次を超えています",
  "alerts.aqiGreaterThanThreshold": "AQI が {value}{unit} のしきい値を超えています",
  "alerts.aqiLessThan": "AQI 未満",
  "alerts.aqiLessThanThreshold": "AQI が {value}{unit} のしきい値未満",
  "alerts.atLeastOneCondition": "少なくとも 1 つの条件を追加する必要があります",
  "alerts.co2GreaterThan": "CO2 が次を超えています",
  "alerts.co2GreaterThanThreshold": "CO2 が {value}{unit} のしきい値を超えています",
  "alerts.co2LessThan": "CO2未満",
  "alerts.co2LessThanThreshold": "CO2 が {value}{unit} しきい値未満",
  "alerts.conditions": "条件",
  "alerts.conditionsDroppedOnStationChange": "この観測所では使用できないため削除しました：{conditions}",
  "alerts.createAlert": "アラートの作成",
  "alerts.dailyPrecipitationGreaterThan": "日降水量が超過",
  "alerts.dailyPrecipitationGreaterThanThreshold": "日降水量が{value}{unit}の閾値を超過",
  "alerts.deleteAlert": "アラートの削除",
  "alerts.deviceOnlyAlertNotice": "アラートはこの端末にのみ保存されます。アカウントに紐付けるにはログインしてください。",
  "alerts.editAlert": "アラートの編集",
  "alerts.editCondition": "条件の編集",
  "alerts.gustSpeedGreaterThan": "突風速度以上",
  "alerts.gustSpeedGreaterThanThreshold": "ガスト速度が {value}{unit} のしきい値を超えています",
  "alerts.gustSpeedLessThan": "ガスト速度未満",
  "alerts.gustSpeedLessThanThreshold": "ガスト速度が {value}{unit} のしきい値未満",
  "alerts.heatIndexGreaterThan": "ヒートインデックスが次を超えています",
  "alerts.heatIndexGreaterThanThreshold": "ヒートインデックスが {value}{unit} のしきい値を超えています",
  "alerts.heatIndexLessThan": "ヒートインデックスが次を下回っています",
  "alerts.heatIndexLessThanThreshold": "ヒートインデックスが {value}{unit} のしきい値を下回っています",
  "alerts.humidexGreaterThan": "ヒュミデックスを超える",
  "alerts.humidexGreaterThanThreshold": "ヒュミデックス が {value}{unit} のしきい値を超えています",
  "alerts.humidexLessThan": "ヒュミデックス未満",
  "alerts.humidexLessThanThreshold": "ヒュミデックス が {value}{unit} のしきい値未満",
  "alerts.humidityGreaterThan": "湿度が次を超えています",
  "alerts.humidityGreaterThanThreshold": "湿度が {value}{unit} のしきい値を超えています",
  "alerts.humidityLessThan": "湿度以下",
  "alerts.humidityLessThanThreshold": "湿度が {value}{unit} のしきい値未満",
  "alerts.inProgress": "進行中",
  "alerts.leafWetnessGreaterThan": "葉の湿り気が次を超えています",
  "alerts.leafWetnessGreaterThanThreshold": "葉の湿り気が {value}{unit} のしきい値を超えています",
  "alerts.leafWetnessLessThan": "葉の湿り気未満",
  "alerts.leafWetnessLessThanThreshold": "葉の湿り気が {value}{unit} のしきい値未満",
  "alerts.myAlerts": "私のアラート",
  "alerts.noAlertsForStation": "この観測所にはまだアラートが設定されていません",
  "alerts.noConfiguredAlert": "まだアラートが設定されていません。アラートの追加を開始してください",
  "alerts.noiseGreaterThan": "ノイズが次を超えています",
  "alerts.noiseGreaterThanThreshold": "ノイズが {value}{unit} のしきい値を超えています",
  "alerts.noiseLessThan": "騒音以下",
  "alerts.noiseLessThanThreshold": "ノイズが {value}{unit} のしきい値未満",
  "alerts.noteOnConditions": "以下の条件がすべて確認された場合にアラートがトリガーされることに注意してください。",
  "alerts.noTriggerHistory": "このアラートはまだ作動していません。",
  "alerts.pm10GreaterThan": "PM10以上",
  "alerts.pm10GreaterThanThreshold": "PM 10 が {value}{unit} のしきい値を超えています",
  "alerts.pm10LessThan": "PM10未満",
  "alerts.pm10LessThanThreshold": "PM 10 が {value}{unit} のしきい値未満",
  "alerts.pm1GreaterThan": "PM1以上",
  "alerts.pm1GreaterThanThreshold": "PM 1 が {value}{unit} のしきい値を超えています",
  "alerts.pm1LessThan": "PM1未満",
  "alerts.pm1LessThanThreshold": "PM 1 が {value}{unit} のしきい値未満",
  "alerts.pm2p5GreaterThan": "PM2.5以上",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 が {value}{unit} のしきい値を超えています",
  "alerts.pm2p5LessThan": "PM2.5未満",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 が {value}{unit} のしきい値未満",
  "alerts.postStormSummary": "降雨後のまとめ",
  "alerts.postStormSynopsisHelper": "降雨イベントが終わるたびに、まとめ通知が届きます。",
  "alerts.postStormSynopsisSoleCondition": "降雨後のまとめは他の条件と組み合わせることはできません。",
  "alerts.precipitationGreaterThan": "1時間降水量が超過",
  "alerts.precipitationGreaterThanThreshold": "1時間降水量が{value}{unit}の閾値を超過",
  "alerts.pressureGreaterThan": "気圧が次を超えています",
  "alerts.pressureGreaterThanThreshold": "気圧が {value}{unit} のしきい値を超えています",
  "alerts.pressureLessThan": "気圧未満",
  "alerts.pressureLessThanThreshold": "気圧が {value}{unit} のしきい値未満です",
  "alerts.pushPromptAccept": "通知をオンにする",
  "alerts.pushPromptBody": "観測所のアラートは通知で届きます。見逃さないように通知をオンにしてください。",
  "alerts.pushPromptBodyCreated": "アラートを保存しました。条件を満たしたときに届くよう、通知をオンにしてください。",
  "alerts.pushPromptTitle": "アラートの発生時に通知を受け取る",
  "alerts.rainRateGreaterThan": "降水強度が超過",
  "alerts.rainRateGreaterThanThreshold": "降水強度が{value}{unit}の閾値を超過",
  "alerts.sensorNotReporting": "このセンサーは現在データを送信していません。送信が再開されるとアラートも再開されます。",
  "alerts.soilMoistureGreaterThan": "土壌水分が次を超えています",
  "alerts.soilMoistureGreaterThanThreshold": "土壌水分が {value}{unit} のしきい値を超えています",
  "alerts.soilMoistureLessThan": "土壌水分未満",
  "alerts.soilMoistureLessThanThreshold": "土壌水分が {value}{unit} のしきい値未満",
  "alerts.solarRadiationGreaterThan": "日射量が超過",
  "alerts.solarRadiationGreaterThanThreshold": "日射量が {value}{unit} のしきい値を超えています",
  "alerts.solarRadiationLessThan": "日射量以下",
  "alerts.solarRadiationLessThanThreshold": "日射量が {value}{unit} のしきい値未満",
  "alerts.stationAlerts": "この観測所のアラート",
  "alerts.stationNoLongerReports": "この観測所はデータを送信しなくなったため、このアラートは作動しません。",
  "alerts.stormChartUnavailable": "この降雨の雨量履歴は利用できません。",
  "alerts.stormDetail": "降雨のまとめ",
  "alerts.stormDuration": "継続時間",
  "alerts.stormEnd": "終了",
  "alerts.stormPeakRate": "最大降雨強度",
  "alerts.stormStart": "開始",
  "alerts.stormTotal": "総降水量",
  "alerts.temperatureGreaterThan": "温度が次を超えています",
  "alerts.temperatureGreaterThanThreshold": "温度が {value}{unit} のしきい値を超えています",
  "alerts.temperatureLessThan": "温度未満",
  "alerts.temperatureLessThanThreshold": "温度が {value}{unit} のしきい値未満",
  "alerts.thresholdOutOfRange": "{min}から{max}の間である必要があります",
  "alerts.thswGreaterThan": "THSWを超える",
  "alerts.thswGreaterThanThreshold": "THSW が {value}{unit} のしきい値を超えています",
  "alerts.thswLessThan": "THSW未満",
  "alerts.thswLessThanThreshold": "THSW が {value}{unit} のしきい値未満",
  "alerts.thwGreaterThan": "THWを超える",
  "alerts.thwGreaterThanThreshold": "THW が {value}{unit} のしきい値を超えています",
  "alerts.thwLessThan": "THW未満",
  "alerts.thwLessThanThreshold": "THW が {value}{unit} のしきい値未満",
  "alerts.triggerHistory": "アラート履歴",
  "alerts.uvGreaterThan": "UV インデックスが次より大きい",
  "alerts.uvGreaterThanThreshold": "UV インデックスが {value}{unit} のしきい値を超えています",
  "alerts.uvLessThan": "UV インデックス未満",
  "alerts.uvLessThanThreshold": "UV インデックスが {value}{unit} のしきい値未満",
  "alerts.visibilityGreaterThanThreshold": "可視性が {value}{unit} のしきい値を超えています",
  "alerts.visibilityLessThanThreshold": "可視性が {value}{unit} のしきい値未満です",
  "alerts.visiblityGreaterThan": "可視性が次を超えています",
  "alerts.visiblityLessThan": "可視性が以下です",
  "alerts.whichMeasure": "どの測定値についてアラートを受け取りたいですか?",
  "alerts.whichModule": "どのモジュールについてアラートを受け取りたいですか？",
  "alerts.whichSensor": "どのセンサーについてアラートを受け取りますか？",
  "alerts.windChillGreaterThan": "ウィンドチルが次を超えています",
  "alerts.windChillGreaterThanThreshold": "ウィンドチルが {value}{unit} のしきい値を超えています",
  "alerts.windChillLessThan": "ウィンドチルが次を下回っています",
  "alerts.windChillLessThanThreshold": "ウィンドチルが {value}{unit} のしきい値を下回っています",
  "alerts.windSpeedGreaterThan": "風速が次を超えています",
  "alerts.windSpeedGreaterThanThreshold": "風速が {value}{unit} のしきい値を超えています",
  "alerts.windSpeedLessThan": "風速以下",
  "alerts.windSpeedLessThanThreshold": "風速が {value}{unit} のしきい値未満",
  "appUpdate.openInBrowser": "ブラウザで開く",
  "appUpdate.reload": "再読み込み",
  "appUpdate.update": "アップデート",
  "appUpdate.updateAvailable": "アップデートがあります",
  "appUpdate.updateAvailableOpenAppStore": "タップして App Store を開く",
  "appUpdate.updateAvailableOpenGooglePlay": "タップして Google Play を開く",
  "appUpdate.updateAvailableVersion": "アップデートがあります: v{version}",
  "appUpdate.upgradeRequiredAndroid": "アプリケーションのアップグレードが必要です。 Google Play にアクセスしてアップグレードしてください。",
  "appUpdate.upgradeRequiredIos": "アプリケーションのアップグレードが必要です。 App Store にアクセスしてアップグレードしてください。",
  "appUpdate.upgradeRequiredTitle": "続けるには SmartMixin をアップデートしてください",
  "appUpdate.webUpdateAvailable": "SmartMixin の新しいバージョンが利用可能です。ページを再読み込みしてご利用ください。",
  "astral.aboveHorizonAllDay": "終日地平線の上",
  "astral.aboveTheHorizon": "地平線の上",
  "astral.apparentSize": "視直径",
  "astral.apparentSizeAcross": "視直径 {size}",
  "astral.astronomicalDawn": "天文薄明開始",
  "astral.astronomicalDusk": "天文薄明終了",
  "astral.belowHorizonAllDay": "終日地平線の下",
  "astral.belowHorizonSince": "{time}から地平線の下",
  "astral.belowHorizonSinceOn": "{day} {time}から地平線の下",
  "astral.brightAllNight": "一晩中明るい — 完全に暗くなる時間なし",
  "astral.brightestMoment": "最も明るい時刻",
  "astral.civilDawn": "市民薄明開始",
  "astral.civilDusk": "市民薄明終了",
  "astral.darkSkyBetween": "暗夜 {from} → {to}",
  "astral.darkSkyWindow": "暗夜 {from} → {to} · 月のない時間 {duration}",
  "astral.dayLength": "昼の長さ",
  "astral.daylightThroughTheYear": "一年間の昼の長さ",
  "astral.dayOfCycle": "{total}日中{day}日目",
  "astral.doesNotOccurToday": "今日はありません",
  "astral.domeHint": "ドラッグして夜をたどる",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "最も早い日の出",
  "astral.earliestSunset": "最も早い日の入り",
  "astral.equinox": "分点",
  "astral.equinoxIn": "{days}日後に分点",
  "astral.evening": "夕方",
  "astral.exactPhaseAt": "{time}ちょうど",
  "astral.firstQuarter": "上弦の月",
  "astral.firstSunriseIn": "{days}日後に最初の日の出",
  "astral.firstSunsetIn": "{days}日後に最初の日の入り",
  "astral.fullMoon": "満月",
  "astral.goldenHourBegins": "ゴールデンアワー開始",
  "astral.goldenHourEnds": "ゴールデンアワー終了",
  "astral.highestPoint": "南中高度",
  "astral.inDays": "{days}日後",
  "astral.lastQuarter": "下弦の月",
  "astral.latestSunrise": "最も遅い日の出",
  "astral.latestSunset": "最も遅い日の入り",
  "astral.litShort": "輝面",
  "astral.longestDay": "最も昼が長い日",
  "astral.lowestPoint": "最低高度",
  "astral.maxAltitudeShort": "最大",
  "astral.midday": "正午",
  "astral.midnightSun": "白夜",
  "astral.midnightSunPeriod": "白夜",
  "astral.milestoneFootnotePolar": "ここでは年間{days, plural, other {#日}}、太陽が昇りも沈みもしないため、通常の日の出・日の入りの極値の代わりに、その期間を表示しています。",
  "astral.milestoneFootnoteTemperate": "最も早い日の入りと最も遅い日の出は最も短い日には当たりません — この2つの日付を決めるのは至点ではなく均時差です。",
  "astral.moon": "月",
  "astral.moonAltitude": "高度",
  "astral.moonDirection": "方位",
  "astral.moonDistance": "距離",
  "astral.moonlessFor": "月のない時間 {duration}",
  "astral.moonPhases": "月の満ち欠け",
  "astral.moonrise": "月の出",
  "astral.moonset": "月の入り",
  "astral.moonUpAllNight": "月は一晩中出ている",
  "astral.moonWashesOutNight": "月は{rise}から{set}まで出ていて、夜空を一晩中明るくする",
  "astral.morning": "朝",
  "astral.nauticalDawn": "航海薄明開始",
  "astral.nauticalDusk": "航海薄明終了",
  "astral.newMoon": "新月",
  "astral.nextDay": "翌日",
  "astral.nextProperlyDarkNight": "次の本当に暗い夜",
  "astral.nextRise": "次の月の出 {time}",
  "astral.nextRiseOn": "次の月の出 {day} {time}",
  "astral.nextSevenNights": "今後7夜",
  "astral.nightDate": "日付",
  "astral.noAstronomicalDarknessTonight": "今夜は天文薄明が終わらない",
  "astral.noDarkNightAhead": "今後2週間はなし",
  "astral.noStationLocation": "位置が不明です",
  "astral.noStationLocationDescription": "このステーションには位置情報が登録されていないため、太陽と月を計算できません。",
  "astral.noSunriseToday": "今日は日の出がありません",
  "astral.nowAtBearing": "現在 高度 {altitude}、方位 {direction}",
  "astral.observing": "観測",
  "astral.ofDaylightLeft": "日照残り",
  "astral.overTheNextThreeWeeks": "今後3週間で",
  "astral.percentLit": "輝面比 {percent}",
  "astral.polarNight": "極夜",
  "astral.polarNightPeriod": "極夜",
  "astral.rightNow": "現在",
  "astral.riseShort": "月の出",
  "astral.setShort": "月の入り",
  "astral.shortestDay": "最も昼が短い日",
  "astral.solarNoon": "南中",
  "astral.solstice": "至点",
  "astral.sunBelowHorizon": "太陽が地平線下 {degrees}°",
  "astral.sunEvents": "太陽のイベント",
  "astral.sunNeverDarkEnough": "太陽が地平線下18°まで沈まない",
  "astral.sunNeverSets": "太陽は沈みません",
  "astral.sunrise": "日の出",
  "astral.sunriseAndSunset": "日の出と日の入り",
  "astral.sunriseAt": "日の出 {time}",
  "astral.sunset": "日没",
  "astral.sunsetAt": "日の入り {time}",
  "astral.thisYearAtNorth": "今年（北緯{degrees}度）",
  "astral.thisYearAtSouth": "今年（南緯{degrees}度）",
  "astral.tonight": "今夜",
  "astral.twilightAllNight": "一晩中薄明 — 完全に暗くなる時間なし",
  "astral.upFor": "出ている時間 {duration}",
  "astral.usableLight": "明るい時間",
  "astral.vsAverage": "平均比 {percent}",
  "astral.vsYesterday": "昨日比",
  "astral.waningCrescent": "欠けていく三日月",
  "astral.waningGibbous": "欠けていく凸月",
  "astral.waxingCrescent": "満ちていく三日月",
  "astral.waxingGibbous": "満ちていく凸月",
  "astral.whereToLook": "見る方向",
  "astral.withoutTheMoon": "月のない時間 {duration}",
  "auth.alreadyHaveAccount": "すでにアカウントをお持ちですか？",
  "auth.authContainerTagline": "あなただけの気象ダッシュボード。ステーションを接続して、リアルタイムデータを手元で確認できます。",
  "auth.backToLogin": "ログインに戻る",
  "auth.checkYourEmail": "メールを確認してください",
  "auth.continueWithApple": "Appleで続行",
  "auth.continueWithFacebook": "Facebookで続行",
  "auth.continueWithGoogle": "Googleで続行",
  "auth.email": "メールアドレス",
  "auth.emailRequiredLoginFacebook": "メールの許可が必要です。",
  "auth.emailVerification": "メール認証",
  "auth.emailVerificationFailure": "メール認証で問題が発生しました。",
  "auth.emailVerificationSuccess": "あなたのメールアドレスは正常に認証されました。",
  "auth.firstName": "名",
  "auth.forgotPassword": "パスワードをお忘れですか？",
  "auth.forgotPasswordSubtitle": "メールアドレスを入力してください。パスワードをリセットするリンクをお送りします。",
  "auth.lastName": "姓",
  "auth.login": "ログイン",
  "auth.loginSubtitle": "おかえりなさい！詳細を入力してください。",
  "auth.loginToSmartMixinDescription": "SmartMixinにログインして、気象観測所へのアクセス、分析の表示、個人用気象ダッシュボードの管理を行えます。",
  "auth.logout": "ログアウト",
  "auth.logoutConfirmation": "ログアウトしますか？",
  "auth.noAccountYet": "アカウントをお持ちではありませんか？",
  "auth.or": "または",
  "auth.password": "パスワード",
  "auth.passwordReset": "パスワードのリセット",
  "auth.passwordResetSuccess": "パスワードは正常に更新されました。",
  "auth.register": "アカウントを作成する",
  "auth.registerDescription": "無料のSmartMixinアカウントを作成して、気象観測所の接続、気象データの追跡、高度な分析ツールへのアクセスが可能になります。",
  "auth.registerSubtitle": "アカウントを作成して始めましょう。",
  "auth.restorePassword": "パスワードを復元する",
  "auth.restorePasswordSuccess": "詳しい手順を記載したパスワード リセット リンクを {emailAddress} に送信しました。",
  "auth.sendReset": "リセット指示を送信する",
  "auth.signInRowDescription": "場所、観測所、アラートをすべての端末で利用できます",
  "auth.signInRowTitle": "ログインまたはアカウントを作成",
  "auth.signInWithApple": "Appleでサインイン",
  "auth.socialAccount": "またはあなたのアカウントを使用してください",
  "auth.staffVerificationCode": "確認コード",
  "auth.staffVerificationExpiresIn": "確認済み。あと{duration}で期限切れになります。",
  "auth.staffVerificationInvalidCode": "コードが正しくありません。もう一度お試しください。",
  "auth.staffVerificationLoginAsStopped": "Login As を停止しました。続行するには Debug 画面で確認コードを入力してください。",
  "auth.staffVerificationNotEnrolled": "お使いのアカウントには認証アプリが設定されていません。バックオフィスのセキュリティ設定で追加してください。",
  "auth.staffVerificationPasskey": "パスキーで確認",
  "auth.staffVerificationPasskeyExpired": "パスキーのリクエストの有効期限が切れました。もう一度お試しください。",
  "auth.staffVerificationPasskeyFailed": "パスキーによる確認に失敗しました。もう一度お試しいただくか、コードを入力してください。",
  "auth.staffVerificationPasskeyNotEnrolled": "このスマートフォンで使用できるアカウントのパスキーがありません。このスマートフォンからバックオフィスのセキュリティ設定でパスキーを追加するか、コードを入力してください。",
  "auth.staffVerificationPasskeySetupLink": "パスキーを追加",
  "auth.staffVerificationPasskeyUnavailable": "ここではパスキーを使用できません。代わりにコードを入力してください。",
  "auth.staffVerificationPrompt": "Login As とユーザー検索を使用するには、認証アプリの6桁のコードまたはリカバリーコードを入力してください。",
  "auth.staffVerificationPromptPasskey": "Login As とユーザー検索を使用するには、パスキーを使用するか、認証アプリの6桁のコードまたはリカバリーコードを入力してください。",
  "auth.staffVerificationSetupLink": "認証アプリを追加",
  "auth.staffVerificationSubmit": "確認",
  "auth.staffVerificationTitle": "スタッフ認証",
  "calendar.afternoon": "午後",
  "calendar.april": "4月",
  "calendar.august": "8月",
  "calendar.changePeriod": "期間: {period}。期間を変更",
  "calendar.currentDay": "当日",
  "calendar.dateFormat": "日付形式",
  "calendar.day": "日",
  "calendar.december": "12月",
  "calendar.durationHours": "{hours}時間",
  "calendar.durationHoursMinutes": "{hours}時間{minutes}分",
  "calendar.durationMinutes": "{minutes}分",
  "calendar.durationMinutesSeconds": "{minutes}分{seconds}秒",
  "calendar.durationSeconds": "{seconds}秒",
  "calendar.earlierYears": "以前の年",
  "calendar.endTime": "終了時刻",
  "calendar.evening": "夜",
  "calendar.february": "2月",
  "calendar.goToNextDay": "次の日",
  "calendar.goToNextMonth": "次の月",
  "calendar.goToNextWeek": "次の週",
  "calendar.goToNextYear": "次の年",
  "calendar.goToPreviousDay": "前の日",
  "calendar.goToPreviousMonth": "前の月",
  "calendar.goToPreviousWeek": "前の週",
  "calendar.goToPreviousYear": "前の年",
  "calendar.hour": "時刻",
  "calendar.hoursCount": "{count, plural, other {#時間}}",
  "calendar.hoursShort": "時間",
  "calendar.hoursShortCount": "{count, plural, other {#時間}}",
  "calendar.january": "1月",
  "calendar.july": "7月",
  "calendar.june": "6月",
  "calendar.last12Hours": "過去12時間",
  "calendar.last24Hours": "過去 24 時間",
  "calendar.last24HoursTo": "{time} までの 24 時間",
  "calendar.last24HoursToYesterday": "昨日 {time} までの 24 時間",
  "calendar.last30Days": "過去 30 日間",
  "calendar.last3Hours": "過去3時間",
  "calendar.last6Hours": "過去6時間",
  "calendar.last7Days": "過去 7 日間",
  "calendar.lastHour": "過去1時間",
  "calendar.laterYears": "以降の年",
  "calendar.march": "3月",
  "calendar.max": "最大",
  "calendar.may": "5月",
  "calendar.month": "月",
  "calendar.monthTotal": "月合計",
  "calendar.morning": "朝",
  "calendar.nextHours": "今後数時間",
  "calendar.night": "未明",
  "calendar.november": "11月",
  "calendar.october": "10月",
  "calendar.oneDay": "1日",
  "calendar.oneHour": "1時間",
  "calendar.oneMonth": "1ヶ月",
  "calendar.oneWeek": "1週間",
  "calendar.periodRangeSpoken": "{start}から{end}まで",
  "calendar.previous24Hours": "前の24時間",
  "calendar.previous30Days": "前の30日間",
  "calendar.previous7Days": "前の7日間",
  "calendar.previousDay": "前日",
  "calendar.previousHours": "過去の時間帯",
  "calendar.previousMonth": "前月",
  "calendar.previousWeek": "前の週",
  "calendar.previousYear": "前年",
  "calendar.sameDayLastYear": "去年の同じ日",
  "calendar.sameMonthLastYear": "去年の同じ月",
  "calendar.selectADate": "日付を選択します",
  "calendar.selectAggregation": "表示する値を選択",
  "calendar.selectAMonth": "月を選択します",
  "calendar.selectAYear": "年を選択してください",
  "calendar.selectGranularity": "粒度を選択してください",
  "calendar.selectPeriod": "期間を選択します",
  "calendar.september": "9月",
  "calendar.sixHours": "6時間",
  "calendar.startTime": "開始時刻",
  "calendar.thirtyMinutes": "30分",
  "calendar.threeHours": "3時間",
  "calendar.timezone": "タイムゾーン",
  "calendar.today": "今日",
  "calendar.untilChanged": "変わるまで",
  "calendar.untilTime": "{time} まで",
  "calendar.untilTodayAt": "今日 {time} まで",
  "calendar.untilTomorrowAt": "明日 {time} まで",
  "calendar.use24HourFormat": "24 時間形式を使用する",
  "calendar.week": "週",
  "calendar.year": "年",
  "calendar.yearToDate": "年初来",
  "calendar.yesterday": "昨日",
  "charts.averageOverThePeriod": "期間中の平均",
  "charts.calendarView": "カレンダービュー",
  "charts.charts": "チャート",
  "charts.chartView": "チャートビュー",
  "charts.comparison": "比較",
  "charts.customizeComparisonMetrics": "比較指標をカスタマイズ",
  "charts.customizeComparisonMetricsDescription": "項目をドラッグして比較指標を並べ替えます。目のアイコンをタップして指標の表示・非表示を切り替えます。",
  "charts.loading": "グラフを読み込み中",
  "charts.maxOverThePeriod": "期間中の最大",
  "charts.measureToDisplay": "表示する測定項目",
  "charts.minMaxRange": "最低 / 最高",
  "charts.noDataForThisPeriod": "この期間のデータはありません",
  "charts.observations": "観測値",
  "charts.observedTemperature": "観測気温",
  "charts.seriesTableDate": "日時",
  "charts.showComparison": "比較を表示",
  "charts.stationComparison": "観測所の比較",
  "charts.stationComparisonDescription": "過去の気象データを他の観測所と比較する",
  "charts.sumOverThePeriod": "期間累計",
  "charts.tableLabel": "{chart}の表",
  "charts.toggleSeries": "{series}の表示・非表示を切り替え",
  "charts.viewAsChart": "グラフ",
  "charts.viewAsList": "リスト",
  "charts.viewAsPeriods": "時間帯",
  "charts.viewAsTable": "表",
  "charts.viewLabel": "{chart}の表示",
  "common.add": "追加",
  "common.altitude": "高度",
  "common.analysis": "分析",
  "common.average": "平均",
  "common.back": "戻る",
  "common.backToHome": "ホームに戻る",
  "common.cancel": "キャンセル",
  "common.cannotBeEmpty": "このフィールドを空にすることはできません。",
  "common.clearSearch": "検索をクリア",
  "common.close": "閉じる",
  "common.dailyForecast": "毎日の天気予報",
  "common.default": "デフォルト",
  "common.delete": "消去",
  "common.details": "詳細",
  "common.edit": "編集",
  "common.exitFullscreen": "全画面表示を終了",
  "common.forecast": "予報",
  "common.frequency": "頻度",
  "common.full": "満充電",
  "common.fullscreen": "全画面表示",
  "common.help": "ヘルプ",
  "common.hidden": "非表示",
  "common.high": "高い",
  "common.iDontKnowYet": "私にはまだ分かりません",
  "common.indoor": "屋内",
  "common.labelValue": "{label}：{value}",
  "common.lastUpdate": "最後の更新",
  "common.low": "低い",
  "common.mapUnavailable": "地図を表示できません",
  "common.maximum": "最大",
  "common.medium": "中くらい",
  "common.minimum": "最小",
  "common.more": "その他",
  "common.moreInformation": "詳細情報",
  "common.moveDown": "下へ移動",
  "common.moveUp": "上へ移動",
  "common.no": "いいえ",
  "common.noAccountNeeded": "アカウント不要",
  "common.noItemsAvailable": "利用できる項目はありません",
  "common.nothingSelected": "未選択",
  "common.notNow": "今はしない",
  "common.now": "現在",
  "common.openSettings": "設定を開く",
  "common.outdoor": "屋外",
  "common.pageNotFound": "ページが見つかりません",
  "common.pageNotFoundDescription": "お探しのページは存在しないか、移動されました。",
  "common.rain": "雨",
  "common.reorderCancel": "{item}の移動をキャンセルしました。{count}件中{position}番目に戻りました。",
  "common.reorderEnd": "{item}を{count}件中{position}番目に配置しました。",
  "common.reorderInstructions": "この項目を移動するには、スペースキーまたはEnterキーを押し、上下の矢印キーで位置を選び、もう一度スペースキーまたはEnterキーを押して配置します。キャンセルするにはEscキーを押します。",
  "common.reorderOver": "{item}は{count}件中{position}番目になりました。",
  "common.reorderStart": "{item}を選択しました。{count}件中{position}番目です。",
  "common.search": "検索",
  "common.share": "共有",
  "common.shareImageFailed": "画像を共有できませんでした",
  "common.shareYourWeather": "天気を共有する",
  "common.skip": "スキップ",
  "common.snackbarWithAction": "{message}。アクション：{action}",
  "common.unknown": "不明",
  "common.validate": "確定",
  "common.validEmail": "有効なメールアドレスが必要です。",
  "common.very_low": "とても低い",
  "common.weatherObservations": "気象観測",
  "common.welcome": "SmartMixin へようこそ!",
  "common.wind": "風",
  "common.yes": "はい",
  "common.zoomImage": "画像を拡大",
  "compass.E": "東",
  "compass.E_long": "東",
  "compass.ENE": "東北東",
  "compass.ENE_long": "東北東",
  "compass.ESE": "東南東",
  "compass.ESE_long": "東南東",
  "compass.N": "北",
  "compass.N_long": "北",
  "compass.NE": "北東",
  "compass.NE_long": "北東",
  "compass.NNE": "北北東",
  "compass.NNE_long": "北北東",
  "compass.NNW": "北北西",
  "compass.NNW_long": "北北西",
  "compass.NW": "北西",
  "compass.NW_long": "北西",
  "compass.S": "南",
  "compass.S_long": "南",
  "compass.SE": "南東",
  "compass.SE_long": "南東",
  "compass.SSE": "南南東",
  "compass.SSE_long": "南南東",
  "compass.SSW": "南南西",
  "compass.SSW_long": "南南西",
  "compass.SW": "南西",
  "compass.SW_long": "南西",
  "compass.W": "西",
  "compass.W_long": "西",
  "compass.WNW": "西北西",
  "compass.WNW_long": "西北西",
  "compass.WSW": "西南西",
  "compass.WSW_long": "西南西",
  "dashboard.currentObservations": "現在の観測結果",
  "dashboard.currentRainEvent": "現在の降雨イベント",
  "dashboard.currentWeatherConditions": "現在の天気",
  "dashboard.customizeDashboard": "カスタマイズ",
  "dashboard.customizeDashboardDescription": "項目をドラッグしてダッシュボードを並べ替えます。目のアイコンをタップしてセクションの表示・非表示を切り替えます。",
  "dashboard.customizeNetatmoDescription": "モジュールをドラッグして、屋外または屋内の中で並べ替えます。目のアイコンをタップしてモジュールの表示・非表示を切り替えます。",
  "dashboard.customizeNetatmoPublicDescription": "モジュールをドラッグして並べ替えます。目のアイコンをタップしてモジュールの表示・非表示を切り替えます。",
  "dashboard.dashboard": "ダッシュボード",
  "dashboard.dayRangeExpected": "{time}に{value}の予想",
  "dashboard.dayRangeReached": "{time}に{value}",
  "dashboard.dayRangeSteady": "終日{value}で安定",
  "dashboard.hiddenSensors": "非表示のセンサー",
  "dashboard.hideSensor": "{sensor}を非表示",
  "dashboard.lastRainEvent": "前回の降雨イベント",
  "dashboard.lastVisibleSensor": "少なくとも1つのセンサーを表示したままにする必要があります。",
  "dashboard.manageSensors": "センサーの管理",
  "dashboard.manageSensorsDescription": "アイテムをドラッグしてセンサーを並べ替えます。目のアイコンをタップしてセンサーの表示/非表示を切り替えます。名前をタップして変更します。",
  "dashboard.manageSensorsDescriptionWeb": "鉛筆をクリックするとセンサーの名前を変更し、ハンドルをドラッグすると一覧の順序を変更し、目をクリックすると非表示または表示を切り替えます。",
  "dashboard.moveSensor": "{sensor}を移動",
  "dashboard.pressureSummary": "気圧の概要",
  "dashboard.rainEvents": "降雨イベント",
  "dashboard.rainSummary": "雨のまとめ",
  "dashboard.renameSensor": "{sensor}の名前を変更",
  "dashboard.shareOutdoorMeasures": "屋外の測定値を共有する",
  "dashboard.shareOutdoorMeasuresDescription": "屋外の測定値を他のユーザーに公開して、SmartMixin コミュニティに参加しましょう。屋内の測定値が共有されることはありません。",
  "dashboard.showSensor": "{sensor}を表示",
  "dashboard.temperatureSummary": "温度の概要",
  "dashboard.useDefaultSensorName": "デフォルトの名前を使用",
  "dashboard.windSummary": "風まとめ",
  "devices.batteryLevel": "バッテリー残量",
  "devices.firmwareVersion": "ファームウェアのバージョン",
  "devices.moduleCount": "{count, plural, other {#台のモジュール}}",
  "devices.moduleType": "モジュールの種類",
  "devices.noNetatmoWeatherStationYet": "Netatmo 気象観測所はまだありません。",
  "devices.noOutdoorModule": "このステーションには機能する屋外モジュールがありません。",
  "devices.notReachable": "接続できません",
  "devices.serialNumber": "シリアルナンバー",
  "devices.signalAverage": "普通",
  "devices.signalBad": "微弱",
  "devices.signalGood": "良好",
  "devices.signalStrength": "シグナル強度",
  "devices.signalUnknown": "不明",
  "devices.visitNetatmoWebsite": "Netatmo Web サイトにアクセスしてください",
  "devices.wifiStrength": "Wi-Fiの強さ",
  "forecastMaps.addColor": "色を追加",
  "forecastMaps.addLayer": "レイヤーを追加",
  "forecastMaps.autoDescription": "この表示範囲で利用できる最適なモデル",
  "forecastMaps.autoDescriptionFree": "プレミアムなし：{model}",
  "forecastMaps.autoPreview": "自動",
  "forecastMaps.autoSwitched": "{model}を表示中：{previous}はこの表示範囲の{coverage, number, percent}をカバー",
  "forecastMaps.backToMaps": "マップ一覧に戻る",
  "forecastMaps.build": "生成",
  "forecastMaps.buildCompleted": "生成が完了しました",
  "forecastMaps.builderMetaDescription": "気象モデルのレイヤーからカスタム予報マップを作成します。",
  "forecastMaps.builderTitle": "マップビルダー",
  "forecastMaps.buildFailed": "生成に失敗しました。もう一度お試しください。",
  "forecastMaps.buildNotPossible": "このマップはまだ生成できません — 利用可能な予報データがありません。",
  "forecastMaps.buildProgress": "レンダリング中… {completed}/{total} ステップ",
  "forecastMaps.buildStarting": "生成を開始しています…",
  "forecastMaps.byModel": "モデル別",
  "forecastMaps.byZone": "ゾーン別",
  "forecastMaps.colormap": "カラーマップ",
  "forecastMaps.colormapCustom": "カスタムカラー",
  "forecastMaps.colormapGroupDomain": "気象プリセット",
  "forecastMaps.colormapGroupMatplotlib": "科学プリセット",
  "forecastMaps.colorStop": "色 {position}",
  "forecastMaps.configUnavailable": "この予報マップは利用できません。代わりに{name}を表示しています。",
  "forecastMaps.contourLevels": "等値線レベル",
  "forecastMaps.countryCanada": "カナダ",
  "forecastMaps.countryFrance": "フランス",
  "forecastMaps.countryGermany": "ドイツ",
  "forecastMaps.countryItaly": "イタリア",
  "forecastMaps.countryScandinavia": "スカンジナビア",
  "forecastMaps.countrySpain": "スペイン",
  "forecastMaps.countrySwitzerland": "スイス",
  "forecastMaps.countryUnitedStates": "アメリカ合衆国",
  "forecastMaps.coverageUnknown": "範囲不明",
  "forecastMaps.coversView": "この表示範囲の{coverage, number, percent}をカバー",
  "forecastMaps.customColormapMinColors": "カスタムカラーマップには少なくとも2色が必要です",
  "forecastMaps.customExtent": "カスタム範囲",
  "forecastMaps.displayName": "表示名",
  "forecastMaps.downscaling": "矢羽の間引き係数",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "範囲を描画",
  "forecastMaps.east": "東",
  "forecastMaps.extentDrawHint": "マップ上をドラッグして範囲を描いてください",
  "forecastMaps.extentInvalid": "西は東より小さく、南は北より小さくする必要があります",
  "forecastMaps.frameTime": "予報時刻",
  "forecastMaps.height": "高さ（インチ）",
  "forecastMaps.hourOffset": "+{hour} 時間",
  "forecastMaps.inThisArea": "この範囲",
  "forecastMaps.invalidHexColor": "無効な色です — #RRGGBB を使用してください",
  "forecastMaps.layerHasErrors": "このレイヤーにはエラーがあります",
  "forecastMaps.layers": "レイヤー",
  "forecastMaps.layerTypeBarbs": "矢羽",
  "forecastMaps.layerTypeContour": "等値線",
  "forecastMaps.layerTypeFilledContour": "塗りつぶし等値線",
  "forecastMaps.layerTypeMagnitude": "大きさ",
  "forecastMaps.layerTypeRaster": "ラスター",
  "forecastMaps.layerTypeVectorField": "ベクトル場",
  "forecastMaps.leave": "移動する",
  "forecastMaps.levelsCount": "本数",
  "forecastMaps.levelsInvalid": "無効な等値線レベルです",
  "forecastMaps.levelsModeArange": "固定間隔",
  "forecastMaps.levelsModeExplicit": "明示的な値",
  "forecastMaps.levelsModeLinspace": "等間隔（本数指定）",
  "forecastMaps.levelsStep": "間隔",
  "forecastMaps.levelsValues": "値",
  "forecastMaps.levelsValuesHint": "カンマ区切り・昇順",
  "forecastMaps.loadingMaps": "地図を読み込んでいます…",
  "forecastMaps.localTimeHint": "現地時間で表示",
  "forecastMaps.lockedConfig": "{model}はプレミアムモデルです。代わりに{fallback}を表示しています。",
  "forecastMaps.lockedVariable": "{variable}、プレミアム",
  "forecastMaps.mapDescription": "説明",
  "forecastMaps.mapName": "マップ名",
  "forecastMaps.mapNameRequired": "名前を入力してください",
  "forecastMaps.mapSettings": "マップ設定",
  "forecastMaps.maxLayersReached": "このマップはレイヤーの上限（{max}）に達しました。",
  "forecastMaps.maxValue": "最大値",
  "forecastMaps.memoryBudgetExceeded": "解像度がレンダリング上限を超えています — DPIまたは高さを下げてください",
  "forecastMaps.memoryBudgetUsage": "レンダリング上限: {percent}%",
  "forecastMaps.metaDescription": "気象モデルの計算結果から生成されたアニメーション予報マップ。",
  "forecastMaps.metric": "気象要素",
  "forecastMaps.metricRequired": "気象要素を選択してください",
  "forecastMaps.metricUnavailable": "このモデルでは利用できません",
  "forecastMaps.minBelowMax": "最小値は最大値より小さくする必要があります",
  "forecastMaps.minMaxRequired": "このレイヤータイプには最小値と最大値が必要です",
  "forecastMaps.minValue": "最小値",
  "forecastMaps.modelChipAuto": "自動 · {model}",
  "forecastMaps.modelCoversView": "{model}はこの表示範囲の{coverage, number, percent}をカバー",
  "forecastMaps.modelNoRun": "完了した計算がまだありません",
  "forecastMaps.modelOption": "{model}、{grid}",
  "forecastMaps.nanClipToMin": "最小値に丸める",
  "forecastMaps.nanMask": "マスク",
  "forecastMaps.nanPolicy": "欠損データ",
  "forecastMaps.nanSkip": "スキップ",
  "forecastMaps.noCompletedRun": "このマップはまだ生成されていません。しばらくしてからご確認ください。",
  "forecastMaps.noLayers": "レイヤーがありません。レイヤーを追加して始めましょう。",
  "forecastMaps.noMapsAvailable": "予報マップはまだありません。",
  "forecastMaps.north": "北",
  "forecastMaps.opacity": "不透明度",
  "forecastMaps.openAsAnimation": "アニメーションで開く",
  "forecastMaps.otherAreas": "その他の地域",
  "forecastMaps.outsideArea": "この範囲をカバーしていません",
  "forecastMaps.overlayLegend": "凡例",
  "forecastMaps.pause": "一時停止",
  "forecastMaps.play": "再生",
  "forecastMaps.pointValueAnnouncement": "{value}、{time}",
  "forecastMaps.pointValueError": "この地点の予報を読み込めませんでした。",
  "forecastMaps.pointValueLoading": "予報を読み込んでいます…",
  "forecastMaps.pointValueUnavailable": "この時刻のデータはありません。",
  "forecastMaps.premiumModelForView": "{model}はこの表示範囲をカバー",
  "forecastMaps.premiumRequired": "予報マップにはプレミアムが必要です",
  "forecastMaps.preview": "プレビュー",
  "forecastMaps.previewEmptyHint": "プレビューを表示するには、有効なレイヤーを1つ以上設定してください。",
  "forecastMaps.previewFailed": "プレビューに失敗しました",
  "forecastMaps.previewHour": "予報時刻（時間）",
  "forecastMaps.previewRendering": "プレビューをレンダリング中…",
  "forecastMaps.projection": "投影法",
  "forecastMaps.projectionLambertConformal": "ランベルト正角円錐",
  "forecastMaps.projectionMercator": "メルカトル",
  "forecastMaps.projectionPlateCarree": "正距円筒（Plate carrée）",
  "forecastMaps.projectionStereographic": "ステレオ投影",
  "forecastMaps.regionEurope": "ヨーロッパ",
  "forecastMaps.regionNorthAmerica": "北アメリカ",
  "forecastMaps.removeColor": "色を削除",
  "forecastMaps.removeLayer": "レイヤーを削除",
  "forecastMaps.retry": "再試行",
  "forecastMaps.run": "ラン: {run}",
  "forecastMaps.runNotDisplayable": "このランはインタラクティブマップに表示できません。",
  "forecastMaps.save": "保存",
  "forecastMaps.selectExtentOnMap": "マップ上で範囲を選択",
  "forecastMaps.showArea": "範囲を表示",
  "forecastMaps.showAreaOf": "範囲を表示、{model}",
  "forecastMaps.south": "南",
  "forecastMaps.switchToModel": "{model}に切り替え",
  "forecastMaps.title": "予報マップ",
  "forecastMaps.uMetric": "U成分",
  "forecastMaps.unitConversion": "単位変換",
  "forecastMaps.unitNone": "なし",
  "forecastMaps.unsavedChangesBody": "保存されていない変更があります。破棄して移動しますか？",
  "forecastMaps.unsavedChangesTitle": "未保存の変更",
  "forecastMaps.useCurrentView": "現在の表示を使用",
  "forecastMaps.useModelDomain": "オフ: モデルの全領域を使用します",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U成分とV成分は異なる必要があります",
  "forecastMaps.valueBetween": "{min}から{max}の間である必要があります",
  "forecastMaps.variable": "変数",
  "forecastMaps.variableMissing": "{variable}は利用できません",
  "forecastMaps.variableOnlyFrom": "{variable}は{model}のみが提供",
  "forecastMaps.vectorLayerFronts": "前線",
  "forecastMaps.vectorLayerIsobars": "等圧線",
  "forecastMaps.vectorLayerWindBarbs": "矢羽",
  "forecastMaps.viewMap": "マップを見る",
  "forecastMaps.vMetric": "V成分",
  "forecastMaps.west": "西",
  "forecastMaps.windAnimation": "風のアニメーション",
  "forecastMaps.windAnimationReduceMotion": "デバイスで動きを減らす設定がオンの間はオフになります",
  "forecastModels.addForecastModel": "モデルを追加",
  "forecastModels.atYourStations": "お使いの観測所で利用可能",
  "forecastModels.comparisonLoadError": "予報モデルの比較を読み込めませんでした",
  "forecastModels.coverageLoading": "各モデルがどの観測所をカバーするか計算しています…",
  "forecastModels.description_AROME": "Météo Franceの対流を解像する高解像度モデル。西ヨーロッパを1.3km解像度でカバー。フランスでの短期予報ではクラス最高。3時間ごとに更新。",
  "forecastModels.description_ARPEGE_EU": "Météo FranceのARPEGEモデルのヨーロッパネストで、解像度は10km。ヨーロッパ上空の中期予報で、1日4回更新。",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo Franceの全球数値天気予報モデル。解像度25kmで約4日間まで予報。1日4回更新。",
  "forecastModels.description_DMI_DINI": "DMIのHARMONIE DINI：北西ヨーロッパ（デンマーク、ベネルクス、アイルランド、英国、スカンジナビア）を対象とした、解像度2kmで60時間先までの対流許容モデル。1日8回更新。改変されたDMIオープンデータ（CC BY 4.0）を含みます。",
  "forecastModels.description_EC_GDPS": "Environment CanadaのGlobal Deterministic Prediction System（全球決定論的予測システム）：解像度15kmで10日先までの世界的な中期モデル。1日2回更新。",
  "forecastModels.description_EC_HRDPS": "Environment CanadaのHigh Resolution Deterministic Prediction System（高解像度決定論的予測システム）：カナダおよび米国北部を対象とした、解像度2.5kmで48時間先までの対流許容モデル。1日4回更新。",
  "forecastModels.description_EC_RDPS": "Environment CanadaのRegional Deterministic Prediction System（地域決定論的予測システム）：北米上空の中期モデルで解像度10km。1日4回更新。",
  "forecastModels.description_ECMWF_HRES": "欧州中期予報センター(ECMWF)の主力高解像度モデル(IFS)。世界最高水準のグローバル予報システムとして広く評価されています。地球全体を25km解像度で最大15日先までカバーし、1日4回更新されます。改変されたECMWFオープンデータ(CC BY 4.0)を含みます。",
  "forecastModels.description_GFS": "NOAAの主力中期全球モデル。解像度25kmで地球全体を16日先までカバーし、1日4回更新。",
  "forecastModels.description_HRRR_CONUS": "NOAAのHigh-Resolution Rapid Refresh：アメリカ本土上空を3km解像度でカバーする対流を解像するモデル。毎時更新。雷雨や悪天候の超短期予報に最適。",
  "forecastModels.description_ICON": "DWDの全球ICONモデル。解像度13 kmで地球全体を7.5日先までカバーし、1日4回更新されます。 Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteoがARPAEと共同運用するICON-2I：イタリアを対象とした、解像度2.2kmで72時間先までの対流許容モデル。1日2回更新。ItaliaMeteoオープンデータ（CC BY 4.0）を含みます。",
  "forecastModels.description_ICON_CH1": "MeteoSwissのICON-CH1-EPSコントロールラン：アルプスを対象とした、解像度1kmで33時間先までの対流許容モデル。3時間ごとに更新。",
  "forecastModels.description_ICON_CH2": "MeteoSwissのICON-CH2-EPSコントロールラン：アルプス（スイスと周辺のアルプス地域）を対象とした、解像度2.1kmで120時間先までの対流許容モデル。1日4回更新。",
  "forecastModels.description_ICON_DE": "DWDの対流を解像する高解像度モデル。ドイツと周辺諸国を2.2km解像度でカバー。短期予報は1日2回更新。 Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWDのICONモデルのヨーロッパネストで、解像度は7km。ヨーロッパと北大西洋をカバー。中期予報は1日4回更新。 Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "ノルウェー気象研究所のオープン天気予報サービス。高解像度の北欧モデルとECMWFデータを組み合わせて、10日先までの世界的な予報を提供。",
  "forecastModels.description_MF_AROME_ANTILLES": "フランス領アンティル諸島（グアドループ、マルティニーク）上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "forecastModels.description_MF_AROME_GUYANE": "フランス領ギアナ上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "ニューカレドニア上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "forecastModels.description_MF_AROME_POLYNESIE": "フランス領ポリネシア上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "レユニオンとマヨット上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "forecastModels.description_RRFS_CONUS": "NOAAのRapid Refresh Forecastシステム。アメリカ本土を3km解像度でカバー。1時間ごとの予報を1日8回更新し、主要な4回は84時間先まで、その他は18時間先まで。",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAAのRapid Refresh Forecastシステム。北米全体を13km解像度でカバー。84時間先までの1時間ごとの予報を1日4回更新。",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixinの主力予報。お客様の場所の毎時に対して、利用可能な最良のモデルを選択します — 通常は存在する場合は高解像度の地域モデル（フランスのAROME、ドイツのICON-D2、米国のHRRR、大陸全体のARPEGE Europeなど）を使用し、他の場所では全球モデルに戻ります — そして近隣のソースからギャップを埋めます。結果は、世界中のどこでも14日間カバーする単一のシームレスな予報であり、基礎となるモデルのいずれかが更新されるたびに自動的に更新されます。",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflowの独自のグローバル予報。複数の数値天気予報モデルと、Tempest気象観測所ネットワークの観測を組み合わせています。10日間の世界的な見通し。",
  "forecastModels.everywhereElse": "それ以外のすべて",
  "forecastModels.everywhereElseFoot": "優先モデルが届かない観測所で使用されます。",
  "forecastModels.everywhereElsePick": "1つ選択",
  "forecastModels.fallbackBlend": "SmartMixin ブレンド",
  "forecastModels.fallbackBlendSub": "複数のモデルを、それぞれが最も得意な場所で組み合わせます。",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES が届く範囲すべてで使用します。",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA の全球モデル。現在すべてのアカウントが使用しています。",
  "forecastModels.fallbackResolution": "最高解像度",
  "forecastModels.fallbackResolutionSub": "各観測所で最も細かい格子（ただし GDPS の優先度は ECMWF と GFS より下）。",
  "forecastModels.forecastChipLabelWithRun": "{model}、ラン {run}",
  "forecastModels.forecastChipRunHint": "長押しで最新のランを表示または非表示",
  "forecastModels.forecastComparisonDescription": "複数のソースからの予報モデル出力を簡単に比較",
  "forecastModels.forecastFollowingPreferences": "設定に従っています",
  "forecastModels.forecastLoadError": "予報を読み込めませんでした",
  "forecastModels.forecastModel": "予報モデル",
  "forecastModels.forecastModelAbout": "{model}について",
  "forecastModels.forecastModelComparison": "予報モデルの比較",
  "forecastModels.forecastModelCoverage": "対象範囲",
  "forecastModels.forecastModelDescription": "説明",
  "forecastModels.forecastModels": "予報モデル",
  "forecastModels.forecastModelScopeGlobal": "全球",
  "forecastModels.forecastModelScopeGlobalDescription": "このモデルは地球全体をカバーします。",
  "forecastModels.forecastModelScopeRegional": "地域",
  "forecastModels.forecastModelScopeRegionalDescription": "このモデルは特定の地域のみをカバーします。",
  "forecastModels.forecastModelSpecifications": "仕様",
  "forecastModels.forecastNoPinLocation": "この位置に届く優先モデルはありません。「それ以外のすべて」が決定します。",
  "forecastModels.forecastNoPinStation": "この観測所に届く優先モデルはありません。「それ以外のすべて」が決定します。",
  "forecastModels.forecastNoPreferredModels": "優先モデルはまだ設定されていません。",
  "forecastModels.forecastOverrideElsewhere": "設定はそれ以外のすべてに適用されます。",
  "forecastModels.forecastPickForLocation": "またはこの位置用に選択",
  "forecastModels.forecastPickForStation": "またはこの観測所用に選択",
  "forecastModels.forecastPinWinsLocation": "{model} — この位置に届く最初の優先モデルです。",
  "forecastModels.forecastPinWinsStation": "{model} — この観測所に届く最初の優先モデルです。",
  "forecastModels.forecastServedNowHere": "現在ここでは {model} です",
  "forecastModels.forecastSetForLocation": "この位置に設定済み",
  "forecastModels.forecastSetForStation": "この観測所に設定済み",
  "forecastModels.forecastSettingsRowSub": "優先モデルと、それ以外のすべてに適用される設定",
  "forecastModels.forecastStopUsingHere": "ここでの使用をやめる",
  "forecastModels.forecastUseForLocation": "この位置で {model} を使う",
  "forecastModels.forecastUseForStation": "この観測所で {model} を使う",
  "forecastModels.forecastUsePreferred": "優先モデルを使う",
  "forecastModels.frequencyHourly": "1 時間ごと",
  "forecastModels.horizon": "予報期間",
  "forecastModels.horizonValue": "最大 {value} 時間",
  "forecastModels.meshSize": "グリッドサイズ",
  "forecastModels.pickerShowAll": "カタログ全体を表示",
  "forecastModels.pickerUnreachable": "{count, plural, other {他 # 件のモデル}}は、いずれの観測所にも届きません",
  "forecastModels.pinInUse": "使用中",
  "forecastModels.pinShadowed": "使用されません — 上位のモデルがすべての観測所をカバーしています",
  "forecastModels.pinSlots": "{max} 件中 {used} 件 · モデルを選択",
  "forecastModels.pinSlotsFull": "{max, plural, =1 {唯一の枠が使用中です。追加するにはそのモデルを削除してください。} other {# 件の枠がすべて使用中です。追加するには 1 つ削除してください。}}",
  "forecastModels.pinsUncoveredCount": "{count, plural, other {# か所中}} {used} か所の観測所には優先モデルが届きません。「それ以外のすべて」が決定します。",
  "forecastModels.pinsUncoveredNamed": "{stations}: {count, plural, other {優先モデルが届きません}}。「それ以外のすべて」が決定します。",
  "forecastModels.pinUnreachable": "使用されません — いずれの観測所にも届きません",
  "forecastModels.pinUsedAt": "{stations} で使用",
  "forecastModels.pinUsedAtAll": "{count, plural, =1 {お使いの観測所で使用} other {# か所すべての観測所で使用}}",
  "forecastModels.pinUsedAtSome": "{count, plural, other {# か所中}} {used} か所の観測所で使用",
  "forecastModels.preferredModels": "優先モデル",
  "forecastModels.preferredModelsAll": "1つのリスト、すべての観測所",
  "forecastModels.preferredModelsOne": "1つのリスト、どこでも適用",
  "forecastModels.publisher": "提供元",
  "forecastModels.removePreferredModel": "{model} を優先モデルから削除",
  "forecastModels.resetForecastPreference": "リセット",
  "forecastModels.resetForecastPreferenceHint": "優先モデルを消去し、SmartMixin の既定に戻します。",
  "forecastModels.servedNowMany": "現在: {count, plural, =1 {お使いの観測所} other {# か所すべての観測所}}で GFS。",
  "forecastModels.servedNowNone": "現在: どこでも GFS。",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin マルチモデル",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow 予報",
  "forecastModels.weatherForecastModels": "天気予報モデル",
  "helpCenter.articleCount": "{count}件の記事",
  "helpCenter.articleNotFound": "記事が見つかりません",
  "helpCenter.articleNotFoundDescription": "お探しの記事は存在しません。",
  "helpCenter.backToHelpCenter": "ヘルプセンターに戻る",
  "helpCenter.browseByCategory": "カテゴリで閲覧",
  "helpCenter.categoryNotFound": "カテゴリが見つかりません",
  "helpCenter.categoryNotFoundDescription": "このカテゴリは存在しないか、記事がありません。",
  "helpCenter.contactSupport": "サポートに問い合わせる",
  "helpCenter.feedbackHelpsImprove": "ご意見はヘルプ記事の改善に役立てられます。",
  "helpCenter.feedbackReasonNotAnswer": "質問の答えになっていない",
  "helpCenter.feedbackReasonOutdated": "情報が古い",
  "helpCenter.feedbackReasonUnclear": "手順がわかりにくい",
  "helpCenter.feedbackWhatWentWrong": "どのような問題がありましたか?",
  "helpCenter.helpCategoryAccount": "アカウント",
  "helpCenter.helpCategoryBilling": "請求",
  "helpCenter.helpCategoryForecast": "予報",
  "helpCenter.helpCategoryGettingStarted": "はじめに",
  "helpCenter.helpCategoryProviders": "プロバイダー",
  "helpCenter.helpCategoryStations": "観測所",
  "helpCenter.helpCategoryTroubleshooting": "トラブルシューティング",
  "helpCenter.helpCenter": "ヘルプセンター",
  "helpCenter.landingDescription": "よくある質問への回答を見つけ、SmartMixinを最大限に活用する方法を学びましょう。",
  "helpCenter.linkToSection": "このセクションへのリンク",
  "helpCenter.menuItemDescription": "よくある質問とガイド",
  "helpCenter.minRead": "{minutes}分で読めます",
  "helpCenter.onThisPage": "このページの内容",
  "helpCenter.platformMobileApp": "モバイルアプリ",
  "helpCenter.platformMobileOnly": "モバイルアプリのみ",
  "helpCenter.platformWebApp": "ウェブアプリ",
  "helpCenter.platformWebOnly": "ウェブアプリのみ",
  "helpCenter.popularArticles": "人気の記事",
  "helpCenter.relatedArticles": "関連記事",
  "helpCenter.searchArticles": "記事を検索...",
  "helpCenter.stillNeedHelp": "まだお困りですか?",
  "helpCenter.stillNeedHelpDescription": "この記事で問題が解決しなかった場合は、直接サポートいたします。",
  "helpCenter.supportEmailSubject": "SmartMixinヘルプ",
  "helpCenter.supportEmailSubjectTopic": "SmartMixinヘルプ — {topic}",
  "helpCenter.thankYouForFeedback": "フィードバックありがとうございます！",
  "helpCenter.wasArticleHelpful": "この記事は役に立ちましたか？",
  "intro.allowLocation": "位置情報を許可",
  "intro.alreadyHaveAccount": "すでにアカウントをお持ちですか？",
  "intro.connectStationDescription": "サービスを選んでください。接続するにはサインインが必要です。",
  "intro.connectStationTitle": "気象観測所を接続",
  "intro.haveWeatherStation": "気象観測所を持っています",
  "intro.locationDescription": "正確な場所に基づいた天気予報を受け取るために、位置情報へのアクセスを許可してください。もう一般的な予報ではありません。",
  "intro.locationTitle": "あなたのための天気予報",
  "intro.showWeatherHere": "現在地の天気を表示",
  "intro.showWeatherInstead": "今はスキップして天気を見る",
  "intro.welcomeDescription": "主要な気象機関による超局地的な予報に加え、世界中の40,000以上の気象観測所からのリアルな現在と過去の気象状況も確認できます。",
  "intro.welcomeTitle": "あなたの天気、再定義",
  "landing.alsoAvailableOn": "以下でも利用可能：",
  "landing.featureAlertsDescription": "あらゆる指標にカスタムのしきい値を設定できます。気温が下がったとき、雨が降り始めたとき、風が強まったときに通知を受け取れます。",
  "landing.featureAlertsTitle": "スマートアラート",
  "landing.featureAnalyticsDescription": "インタラクティブなグラフ、トレンド分析、詳細な統計。気温、湿度、気圧、雨、風のデータを深く掘り下げられます。",
  "landing.featureAnalyticsTitle": "高度な分析",
  "landing.featureExportDescription": "すべての気象データを Excel スプレッドシートとしてメールで受け取り、Excel、Google スプレッドシート、お気に入りのツールでさらに分析できます。",
  "landing.featureExportTitle": "データをエクスポート",
  "landing.featureForecastDescription": "ECMWF、GFS、地域モデルなど、{count, plural, other {# 以上}}のプロ向け予報モデルを利用できます。並べて比較して、自分なりの予想を立てましょう。",
  "landing.featureForecastTitle": "予報モデルを比較",
  "landing.featureHistoryDescription": "時間単位、日単位、月単位のスケールで過去データにアクセス。研究や個人アーカイブ用に Excel へエクスポートできます。",
  "landing.featureHistoryTitle": "豊富な履歴",
  "landing.featureMultiBrandDescription": "Netatmo、Davis、Tempest、Ecowitt、Ambient Weather などを接続。もうアプリを切り替える必要はありません。",
  "landing.featureMultiBrandTitle": "すべてのブランドをひとつのアプリで",
  "landing.featuresSubtitle": "SmartMixin には、気象データをプロのように分析・比較・理解するためのツールがそろっています。",
  "landing.featuresTitle": "データ好きのために",
  "landing.finalCtaButton": "無料アカウントを作成",
  "landing.finalCtaSubtitle": "SmartMixin を信頼する数千人の気象愛好家の仲間になりましょう。",
  "landing.finalCtaTitle": "気象データをもっと深く掘り下げてみませんか？",
  "landing.heroCta": "無料で始める",
  "landing.heroDescription": "詳細な分析、美しいグラフ、プロ仕様の予報 — すべての気象観測所をひとつのパワフルなアプリに。",
  "landing.heroSecondaryCta": "マップを見る",
  "landing.heroTagline": "気象愛好家のために",
  "landing.heroTitle": "天気を、これまでにない視点で",
  "landing.pricingComparisonCaption": "無料プランとプレミアムの機能比較",
  "landing.pricingFeatureAdvancedMetrics": "高度な指標",
  "landing.pricingFeatureAlerts": "カスタムアラート",
  "landing.pricingFeatureColumn": "機能",
  "landing.pricingFeatureExport": "データエクスポート（Excel）",
  "landing.pricingFeatureForecastComparison": "予報モデル比較",
  "landing.pricingFeatureForecasts": "予報モデル",
  "landing.pricingFeatureForecastsFreeTier": "1モデル",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, other {# 以上のモデル}}",
  "landing.pricingFeatureReports": "分析とレポート",
  "landing.pricingFeatureStationComparison": "観測所の比較",
  "landing.pricingFeatureWidgets": "ホーム画面ウィジェット",
  "landing.pricingFeatureYearOverYear": "前年比分析",
  "landing.pricingFreeCta": "始める",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "人気No.1",
  "landing.pricingPremiumCta": "始める",
  "landing.pricingPremiumDescription": "月額1.99€から — ウェブ、App Store、Google Playで購読",
  "landing.pricingSubtitle": "無料で始めて、必要に応じてアップグレード。",
  "landing.pricingTitle": "シンプルで透明な料金",
  "landing.statBrands": "対応ブランド",
  "landing.statForecasts": "予報モデル",
  "landing.statStations": "気象観測所",
  "landing.supportedDevicesNote": "さらに世界気象機関のネットワークから {count, number} 以上の公共観測所",
  "landing.supportedDevicesSubtitle": "お手持ちの気象観測所を数分で接続。主要 {count, plural, other {# ブランド}}に対応し、今後も拡大予定です。",
  "landing.supportedDevicesTitle": "お使いの観測所に対応",
  "metrics.absolutePressure": "絶対気圧",
  "metrics.airDensity": "空気密度",
  "metrics.airGap": "エアギャップ",
  "metrics.apparentTemperature": "見かけの温度",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "平均",
  "metrics.avg_wind": "平均風速",
  "metrics.beaufort": "ビューフォート",
  "metrics.blackGlobeTemperature": "黒球温度",
  "metrics.boilerOn": "ボイラーON",
  "metrics.boilerOnInHours": "ボイラーON（時間）",
  "metrics.cloudCover": "雲量",
  "metrics.co2": "CO2",
  "metrics.conductivity": "導電率",
  "metrics.dailyPrecipitation": "日降水量",
  "metrics.dailyRain": "日降水量",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "深さ",
  "metrics.depthSensors": "深度センサー",
  "metrics.dewPoint": "露点",
  "metrics.distance": "距離",
  "metrics.downTrend": "下降",
  "metrics.ET": "蒸発散量",
  "metrics.etToday": "今日の蒸発散量",
  "metrics.feelsLike": "体感温度",
  "metrics.feelsLikeWithFormula": "体感温度（{formula}）",
  "metrics.frostPoint": "霜点",
  "metrics.gust": "突風",
  "metrics.gustDirection": "突風の風向",
  "metrics.hail": "ひょう",
  "metrics.heatIndex": "ヒートインデックス",
  "metrics.heatingDegreeDays": "暖房度日",
  "metrics.heatingPower": "暖房出力",
  "metrics.humidex": "ヒュミデックス",
  "metrics.humidity": "湿度",
  "metrics.lastLightningImpact": "最終落雷",
  "metrics.lastMeasure": "最新の測定値",
  "metrics.leafSensors": "葉センサー",
  "metrics.leafWetness": "葉の湿り気",
  "metrics.lightningDistance": "距離",
  "metrics.lightningStrikeCount": "落雷回数",
  "metrics.lightningStrikeDistance": "落雷距離",
  "metrics.max": "最高",
  "metrics.max_gust": "最大瞬間風速",
  "metrics.maxToday": "本日の最大",
  "metrics.min": "最低",
  "metrics.noise": "ノイズ",
  "metrics.normalizedHeatingCoefficient": "正規化された発熱係数",
  "metrics.outdoorTemperature": "屋外温度",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "降水量",
  "metrics.pressure": "気圧",
  "metrics.rain": "雨",
  "metrics.rainDurationValue": "降雨時間：{duration}",
  "metrics.rainRate": "降水強度",
  "metrics.relativePressure": "相対気圧",
  "metrics.setPoint": "設定値",
  "metrics.snow": "雪",
  "metrics.snowfall": "降雪量",
  "metrics.soilMoisture": "水分",
  "metrics.soilSensors": "土壌センサー",
  "metrics.soilWaterTension": "土壌水分張力",
  "metrics.solarEnergy": "太陽光エネルギー",
  "metrics.solarRadiation": "日射",
  "metrics.speed": "スピード",
  "metrics.stableTrend": "安定",
  "metrics.sum": "合計",
  "metrics.temperature": "温度",
  "metrics.temperatureSensors": "温度および湿度センサー",
  "metrics.temperatureShort": "気温",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "上昇",
  "metrics.uv": "紫外線",
  "metrics.visibility": "視程",
  "metrics.weatherCondition": "天気の状態",
  "metrics.wetBulbGlobeTemperature": "湿球黒球温度",
  "metrics.wetBulbTemperature": "湿球温度",
  "metrics.wind": "風",
  "metrics.windChill": "ウィンドチル",
  "metrics.windDirection": "風向",
  "metrics.windRun": "風程",
  "metrics.windRunDescription": "風程は、一定期間に風が移動した総距離です",
  "metrics.windSpeed": "風速",
  "navigation.allFavorites": "すべて表示",
  "navigation.breadcrumbs": "パンくずリスト",
  "navigation.collapseNavigation": "ナビゲーションを折りたたむ",
  "navigation.expandNavigation": "ナビゲーションを展開",
  "navigation.main": "メイン",
  "navigation.mapShort": "マップ",
  "navigation.skipToContent": "メインコンテンツへスキップ",
  "network.cancelError": "リクエストはキャンセルされました",
  "network.connectionError": "サーバーが利用できません",
  "network.networkError": "ネットワークが利用できません",
  "network.serverError": "何か問題が発生しました...",
  "network.timeoutError": "接続タイムアウト",
  "network.tooManyRequests": "リクエストが多すぎます。しばらくしてからお試しください。",
  "network.unknownError": "不明なエラー",
  "premium.alreadyPremium": "あなたはすでにプレミアムアカウントをお持ちです!",
  "premium.bestValue": "ベストバリュー",
  "premium.billingDetailsAndroid": "無料トライアル：トライアル終了の 24 時間以上前にキャンセルすれば、料金はかかりません。その後、SmartMixin のサブスクリプションは、現在の期間が終了する 24 時間以上前にキャンセルしない限り自動更新されます。キャンセルは Google Play のアカウント設定からいつでも行えます。各更新は上のボタンに表示されている価格で請求されます。お支払いは、購入の確定時と各更新期間の開始時に Google Play アカウントに請求されます。",
  "premium.billingDetailsIos": "無料トライアル：トライアル終了の 24 時間以上前にキャンセルすれば、料金はかかりません。その後、SmartMixin のサブスクリプションは、現在の期間が終了する 24 時間以上前にキャンセルしない限り自動更新されます。キャンセルは App Store のアカウント設定からいつでも行えます。各更新は上のボタンに表示されている価格で請求されます。お支払いは、購入の確定時と各更新期間の開始時に App Store アカウントに請求されます。",
  "premium.freeBannerBody": "プレミアムに未登録の場合は、どこでも GFS が提供されます。優先モデルと「それ以外のすべて」は、ご登録と同時に有効になります。",
  "premium.freeBannerTitle": "設定はプレミアムで有効になります",
  "premium.freeSubscription": "無料のプレミアム購読",
  "premium.freeTrialForPeriod": "{period, plural, other {# 日間}}の無料トライアル",
  "premium.getUnlimitedAccess": "無制限アクセス:",
  "premium.manageMySubscription": "サブスクリプションを管理する",
  "premium.notPurchasedYet": "このストアアカウントには SmartMixin プレミアムの購入が見つかりませんでした。",
  "premium.orChooseMonthly": "または月額を選択：",
  "premium.plansRetry": "再試行",
  "premium.plansUnavailable": "サブスクリプションプランを読み込めませんでした。インターネット接続を確認して、もう一度お試しください。",
  "premium.premium": "SmartMixin プレミアム",
  "premium.premiumActive": "アクティブ",
  "premium.premiumAnnualTrialInfo": "{days, plural, other {# 日間}}の無料トライアルから始めましょう",
  "premium.premiumCurrentPlan": "現在のプラン",
  "premium.premiumDownloadApp": "購読するにはアプリをダウンロード：",
  "premium.premiumEndsOn": "{date}に終了",
  "premium.premiumFeatureAlerts": "気象アラート",
  "premium.premiumFeatureAnalysis": "高度な気象分析",
  "premium.premiumFeatureCharts": "チャート比較",
  "premium.premiumFeatureExport": "データエクスポート",
  "premium.premiumFeatureForecast": "地域予報モデル",
  "premium.premiumFeatureNotification": "ステータスバーウィジェット",
  "premium.premiumFeatureTitle": "プレミアム機能",
  "premium.premiumFeatureWidgets": "ホーム画面ウィジェット",
  "premium.premiumFreePlan": "無料",
  "premium.premiumInactive": "未購読",
  "premium.premiumManageStoreSubscription": "{store} で購読しています。管理や解約はそちらで行ってください。",
  "premium.premiumManageWebSubscription": "サブスクリプションの管理、支払い方法の更新、またはキャンセル。",
  "premium.premiumPremiumPlan": "プレミアム",
  "premium.premiumRenewsOn": "{date}に更新",
  "premium.premiumSubscribeAnnual": "年額 — 9.99 €/年",
  "premium.premiumSubscribedOn": "{platform}で購読中",
  "premium.premiumSubscribedOnWeb": "ウェブで購読中",
  "premium.premiumSubscribeMonthly": "月額 — 1.99 €/月",
  "premium.premiumSubscribeOnWeb": "今すぐ登録して、すべてのプレミアム機能をアンロックしましょう。",
  "premium.premiumSubscriptionSuccess": "サブスクリプションが有効になりました！すべてのプレミアム機能をお楽しみください。",
  "premium.premiumSubscriptionSuccessTitle": "プレミアムへようこそ！",
  "premium.premiumWebappNotice": "現在、ウェブでの購読はご利用いただけません。",
  "premium.pricePerMonth": "{price}/月",
  "premium.pricePerYear": "{price}/年",
  "premium.purchasedNetatmoPro": "以前に Netatmo Pro ({date}) を購入しました。これにより、プレミアム機能のサブセットにアクセスできるようになります。すべてのプレミアム機能にアクセスしたい場合は、次のいずれかのオファーに登録してください。",
  "premium.purchaseFailed": "購入を完了できませんでした。もう一度お試しください。",
  "premium.restoreFailed": "購入を復元できませんでした。もう一度お試しください。",
  "premium.restorePurchase": "購入商品を復元する",
  "premium.savingsPercent": "{percent}%お得",
  "premium.seePremium": "プレミアムを見る",
  "premium.startFreeTrial": "無料トライアルを開始",
  "premium.storeUnavailable": "現在ストアを利用できません。しばらくしてからもう一度お試しください。",
  "premium.subscribeNow": "今すぐ登録 — トライアルなし",
  "premium.switchToPremium": "SmartMixin プレミアムに切り替える",
  "premium.thenPrice": "その後 {price}",
  "providerHints.ambientWeatherApiKey": "ambientweather.net のアカウント設定で作成します。",
  "providerHints.davisApiSecret": "V2 API キーを作成したときに一度だけ表示されます — 大切に保管してください。",
  "providerHints.davisV2ApiKey": "weatherlink.com の V2 API キーのページから取得します。",
  "providerHints.ecowittApi": "Ecowitt アカウントの API ページから取得します。",
  "providerHints.ecowittApp": "アプリケーションキーも Ecowitt アカウントから取得します。",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite アカウントのメールとパスワードを使用してください — SmartMixin のログインではありません。",
  "providerHints.myAcuriteEmail": "My AcuRite アカウントのメールアドレス — SmartMixin のログインではありません。",
  "providerHints.myAcuritePassword": "My AcuRite アカウントのパスワード。",
  "providerHints.weatherflowToken": "tempestwx.com → 設定 → データ認証から取得する個人利用トークン。",
  "providerHints.wundergroundEditKey": "別のキーを使用する",
  "providerHints.wundergroundKey": "Weather Underground アカウントの API キーページから取得する長い文字列です — wunderground.com のパスワードではありません。",
  "providerHints.wundergroundKeyExample": "例: 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API キーを確認しました",
  "providerHints.wundergroundNoStationsNearby": "この場所の近くにステーションが見つかりません。ステーション ID を直接入力してみてください。",
  "providerHints.wundergroundStationIdExample": "例: KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather の API キーを取得してください。",
  "providerIntro.davisStep2": "Davis の V2 API キーと API シークレットを取得してください。",
  "providerIntro.ecowittStep2": "Ecowitt の API キーとアプリケーションキーを取得してください。",
  "providerIntro.getStarted": "始める",
  "providerIntro.myAcuriteStep2": "既存の My AcuRite アカウントのメールとパスワードを使用してください。",
  "providerIntro.netatmoEnergyStep2": "プロンプトが表示されたら Netatmo にサインインしてください — API キーは不要です。",
  "providerIntro.netatmoWeatherStep2": "プロンプトが表示されたら Netatmo にサインインしてください — API キーは不要です。",
  "providerIntro.signupBanner": "もう少しです — {provider} を接続するために無料の SmartMixin アカウントを作成してください。",
  "providerIntro.step1": "SmartMixin アカウントにサインインしてください（{provider} のログインではありません）。",
  "providerIntro.step3EmailPassword": "ここに入力してください。",
  "providerIntro.step3KeyOrToken": "ここに貼り付けてください。",
  "providerIntro.step3OAuth": "ポップアップで SmartMixin を承認してください。",
  "providerIntro.step3Wunderground": "API キーを貼り付けてから、近くのステーションを選択するか、任意のステーション ID を入力してください。",
  "providerIntro.stepOfTotal": "ステップ {step}/{total}",
  "providerIntro.title": "{provider} を接続する",
  "providerIntro.weatherflowStep2": "Tempest の個人利用トークンを取得してください。",
  "providerIntro.wundergroundBrowsePublic": "ステーションをお持ちでない方は公開ステーションを探す",
  "providerIntro.wundergroundFindNearby": "近くのステーションを探す",
  "providerIntro.wundergroundOrEnterId": "またはステーション ID を入力する",
  "providerIntro.wundergroundStep2": "Weather Underground の API キーを取得してください。その後、ご自身のものでも公開ステーションでも、任意のステーションを接続できます。",
  "reports.agroMeteorology": "農業気象学",
  "reports.analysis": "分析",
  "reports.annualCumulativeRainfallComparison": "年間累積降水量の比較",
  "reports.annualHeatingDurationComparison": "年間暖房時間の比較",
  "reports.annualHeatingEfficiency": "年間暖房効率",
  "reports.annualIndoorComparison": "年間屋内比較",
  "reports.annualOutdoorComparison": "年間屋外比較",
  "reports.annualOutdoorReport": "年間屋外レポート",
  "reports.annualReport": "年次報告",
  "reports.annualSolarReport": "年次太陽報告書",
  "reports.annualWaterBalance": "年間の水収支",
  "reports.annualWaterBalanceCarryOver": "{year}年から繰り越し ({value})",
  "reports.annualWaterBalanceDescription": "水バランス（簡易版、雨と蒸発散のみを使用）は給水管理に役立ちます",
  "reports.avgHumidity": "平均湿度",
  "reports.avgMaxTemperature": "平均最高気温",
  "reports.avgMetric": "平均{metric}",
  "reports.avgMinTemperature": "平均最低気温",
  "reports.avgPressure": "平均気圧",
  "reports.avgTemperature": "平均温度",
  "reports.chartsAndTable": "グラフと表",
  "reports.climateNormalPeriodOfRecord": "統計期間（{years}年）",
  "reports.climateNormals": "平年値",
  "reports.climateNormalStandardLabel": "標準平年値（{period}）",
  "reports.climateTrendPerDecade": "気温の変化傾向：{value}／10年（{years}年間）",
  "reports.coldestMonthRanking": "観測史上最も寒い{month}",
  "reports.comfortable": "快適 (45% {lessThan} 湿度 ≤ 60%)",
  "reports.coverageAllDays": "{total, plural, other {全 # 日}}",
  "reports.coverageMetricsCount": "{metrics}: {total, plural, other {# 日中}} {count} 日",
  "reports.coverageMetricsEveryDay": "{metrics}: 毎日",
  "reports.coverageMonthToDate": "月初来",
  "reports.coverageNoReadings": "観測値なし: {dates}",
  "reports.coverageReadingsCount": "{total, plural, other {# 日中}} {count} 日に観測値あり",
  "reports.coverageTodayUntil": "今日 {time} まで",
  "reports.coverageYearToDate": "年初来",
  "reports.cumulativeRainfall": "累積降水量",
  "reports.cumulativeRainfallDescription": "選択した期間に蓄積した総降水量を確認できます。",
  "reports.dailyMaxRainfall": "日最大降水量",
  "reports.dataExport": "データのエクスポート",
  "reports.dataExportXlsxFormatDescription": "ステーションのすべてのデータを Excel 形式 (*.xlsx) でエクスポートします。ボタンをクリックすると、数分後に処理されたデータが記載された電子メールが届きます。",
  "reports.daysOfData": "{days}日分のデータ",
  "reports.daysWithFrost": "冬日",
  "reports.daysWithHeavyRain": "大雨の日数（≥ {threshold}）",
  "reports.daysWithoutThaw": "真冬日",
  "reports.daysWithStrongFrost": "強い冷え込みの日",
  "reports.emailSent": "電子メールがあなたのメールボックスに送信されました",
  "reports.frostDays": "冬日",
  "reports.grasslandTemperatureSum": "草地温度合計",
  "reports.grasslandTemperatureSumDescription": "春に {threshold} の合計を超えた場合、植生の持続可能な開始に達しています (ヨーロッパで機能)",
  "reports.grasslandThresholdLabel": "植生の開始：{threshold}",
  "reports.growingDegreeDays": "生育度日",
  "reports.highPressure": "高気圧 (平均気圧 ≥ {threshold})",
  "reports.historyImportInProgress": "お使いの観測所の過去の履歴をまだ取り込み中です。今後数日のうちに、さらに前の年が表示されます。",
  "reports.iceDays": "真冬日",
  "reports.indoorReport": "インドアレポート",
  "reports.keyFacts": "重要な事実",
  "reports.longestDrySpell": "最長無降水日数",
  "reports.longestRunOfRainyDays": "最長連続降雨日数",
  "reports.longestRunWithoutRun": "最長連続無降雨日数",
  "reports.longestWetSpell": "最長連続降水日数",
  "reports.lowPressure": "低気圧 (平均気圧 {lessThan} {threshold})",
  "reports.maxHumidity": "最大湿度",
  "reports.maxMetric": "最大{metric}",
  "reports.maxPressure": "最高気圧",
  "reports.maxTemperature": "最高温度",
  "reports.maxTempGreaterThan": "T°max ≧",
  "reports.maxTempMagnitude24h": "最大日較差",
  "reports.minHumidity": "最低湿度",
  "reports.minMetric": "最小{metric}",
  "reports.minPressure": "最低気圧",
  "reports.minTemperature": "最低温度",
  "reports.minTempMagnitude24h": "最小日較差",
  "reports.monthlyAverageCountdown": "今月はあと{days}日",
  "reports.monthlyAverageCountdownDetail": "そのとき今月の平均と順位が表示されます。",
  "reports.monthlyAverageRule": "暦月に{days}日分のデータが記録されると、月平均と順位が表示されます。",
  "reports.monthlyHeatingEfficiency": "月間暖房効率",
  "reports.monthlyOutdoorReport": "月間屋外レポート",
  "reports.monthlyReport": "月例報告",
  "reports.monthlySolarReport": "月次ソーラーレポート",
  "reports.monthlyWindReport": "月次風力レポート",
  "reports.monthsOfData": "{months}ヶ月分のデータ",
  "reports.noReadings": "観測値なし",
  "reports.numberOfDays": "日数",
  "reports.onThisDayChartRule": "{date}の記録が{count}年分たまると、年ごとのグラフが表示されます。",
  "reports.onThisDayChartSummary": "気温のある{years, plural, other {#年分}}、{first}年から{last}年。最高気温の記録 {high}（{highYears}年）、最低気温の記録 {low}（{lowYear}年）。平年の日は{min}〜{max}。",
  "reports.onThisDayChartSummaryNoNormal": "気温のある{years, plural, other {#年分}}、{first}年から{last}年。最高気温の記録 {high}（{highYears}年）、最低気温の記録 {low}（{lowYear}年）。",
  "reports.onThisDayCoverage": "{firstYear}年から{years}年分",
  "reports.onThisDayDataSince": "この観測所には{date}からのデータがあります。",
  "reports.onThisDayEveryYear": "記録上のすべての{date}",
  "reports.onThisDayGapNoData": "データなし",
  "reports.onThisDayHighOnlySummary": "{year}年：最高 {max}、雨量 {rain}",
  "reports.onThisDayInHistory": "過去の同じ日の記録",
  "reports.onThisDayLeaveOk": "この画面を離れても読み込みは続きます。",
  "reports.onThisDayLoadFailed": "{date}を読み込めませんでした。接続を確認して、もう一度お試しください。",
  "reports.onThisDayLowOnlySummary": "{year}年：最低 {min}、雨量 {rain}",
  "reports.onThisDayNoDataRun": "{start}–{end}年 · データなし（{count}年）",
  "reports.onThisDayNormal": "平年の日：{min}〜{max}",
  "reports.onThisDayNoYears": "{date}の完全な記録はまだありません",
  "reports.onThisDayNoYearsDetail": "このページは、観測所が初めて{date}を完全に記録した時点から表示されます。",
  "reports.onThisDayNoYearSelected": "年が選択されていません",
  "reports.onThisDayOneReading": "測定1回",
  "reports.onThisDayOneReadingSummary": "{year}年：{value}、測定1回、雨量 {rain}",
  "reports.onThisDayOpenRecords": "記録と気候を開く",
  "reports.onThisDayPickHint": "表示する日を変更します",
  "reports.onThisDayPickTitle": "日を選択",
  "reports.onThisDayRain": "{date}の雨量",
  "reports.onThisDayRainNotMeasured": "未計測",
  "reports.onThisDayRainOnlySummary": "{year}年：雨量 {rain}",
  "reports.onThisDayRainSince": "雨量は{year}年から",
  "reports.onThisDayRainSummary": "{date}の雨量。最も雨の多かった日 {value}（{years}年）。",
  "reports.onThisDayRetry": "再試行",
  "reports.onThisDaySingleReading": "その日の測定値が1つしかない年（{count}年）はグラフに表示されません。",
  "reports.onThisDaySlowLoad": "{date}の{years}年分を読み込んでいます。日付を初めて表示するときは最大20秒かかることがあります。",
  "reports.onThisDaySlowLoadGeneric": "この観測所の{date}の履歴を読み込んでいます。日付を初めて表示するときは最大20秒かかることがあります。",
  "reports.onThisDayTied": "{years}年と同値",
  "reports.onThisDayTiedMore": "{years}年ほか{count}年と同値",
  "reports.onThisDayYearSummary": "{year}年：最低 {min}、最高 {max}、雨量 {rain}",
  "reports.onThisDayYearTied": "{year}（{tied}）",
  "reports.outdoorReport": "屋外レポート",
  "reports.overviewSection": "概要",
  "reports.rainfall": "降雨",
  "reports.rainyDays": "雨の日",
  "reports.recordCalendarDay": "暦日 (0時から0時まで)",
  "reports.recordClimatologicalDay": "気候学的日 (06–06 UTC)",
  "reports.recordClimDayBody": "最も雨の多かった日は2通りの方法で集計しています。暦日は観測所の時刻で0時から0時まで、気候学的日は気象機関と同じく 06:00 から 06:00 UTC までです。同じ嵐でも区切り方が異なるため、合計値が異なることがあり、日付が異なることもあります。",
  "reports.recordDailyRain": "最も雨の多かった日",
  "reports.recordFromHourlyReadings": "毎時の観測による値",
  "reports.recordHigh": "最高気温の記録",
  "reports.recordLow": "最低気温の記録",
  "reports.recordOfficialBody": "気象機関は、この観測所について最高・最低温度計で読み取った日最高・日最低気温を公表しています。毎時の観測では捉えきれない短時間のピークを捉えるため、毎時の観測から求めた値の代わりに使われます。",
  "reports.recordOfficialValue": "公式値",
  "reports.recordsAndClimatology": "記録と気候",
  "reports.recordSheetTitle": "これらの記録について",
  "reports.recordsSince": "{date}以降の記録",
  "reports.recordWindGust": "最大瞬間風速の記録",
  "reports.relativelyWet": "比較的湿った状態 (60% {lessThan} 湿度 ≤ 80%)",
  "reports.sectionReportCount": "{count}件のレポート",
  "reports.sendEmail": "メールを送る",
  "reports.summerDays": "夏日",
  "reports.tableScrollRegion": "{title}、横にスクロールできます",
  "reports.tooDry": "乾燥しすぎ (湿度 ≤ 45%)",
  "reports.tooWet": "湿りすぎ (湿度 {greaterThan} 80%)",
  "reports.tropicalNights": "熱帯夜",
  "reports.unlockPremiumSubtitle": "SmartMixin Premium に含まれます",
  "reports.unlockPremiumTitle": "{count}件のプレミアム機能をロック解除",
  "reports.warmestMonthRanking": "観測史上最も暑い{month}",
  "reports.waterBalance": "水収支",
  "reports.yearsOfData": "{years}年分のデータ",
  "reports.yearToDateTemperatureComparison": "年初から今日までの気温の比較",
  "sensors.bgtSensors": "黒球温度 & WBGT",
  "sensors.cameraFeed": "カメラ",
  "sensors.compareHumidity": "湿度を比較",
  "sensors.compareMoisture": "土壌水分を比較",
  "sensors.comparePm25": "PM2.5を比較",
  "sensors.compareTemperatures": "温度を比較",
  "sensors.compareWaterTension": "土壌水分張力を比較",
  "sensors.depthByChannel": "チャンネル別深度",
  "sensors.heatStressExtreme": "極度の熱ストレス",
  "sensors.heatStressModerate": "中程度の熱ストレス",
  "sensors.heatStressNone": "熱ストレスなし",
  "sensors.heatStressStrong": "強い熱ストレス",
  "sensors.heatStressVeryStrong": "非常に強い熱ストレス",
  "sensors.indoorClimate": "室内気候",
  "sensors.indoorCo2Levels": "CO2レベル",
  "sensors.indoorTemperatureAndHumidity": "温度と湿度",
  "sensors.leafWetnessByChannel": "チャンネル別葉面湿度",
  "sensors.lightningSensor": "雷",
  "sensors.moistureByChannel": "チャンネル別土壌水分",
  "sensors.noDataAvailable": "データがありません",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "チャンネル別PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "チャンネルを選択",
  "sensors.sensorDetailDescription": "センサーチャンネルの履歴データとトレンドを表示します。",
  "sensors.sensorHistory": "センサー履歴",
  "sensors.soilConductivityByChannel": "チャンネル別導電率",
  "sensors.soilTemperatureByChannel": "チャンネル別土壌温度",
  "sensors.strikesToday": "今日の落雷数",
  "sensors.temperatureByChannel": "チャンネル別温度",
  "sensors.viewChart": "グラフを表示",
  "sensors.waterTensionByChannel": "チャンネル別土壌水分張力",
  "settings.appearance": "外観",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "アラビア語",
  "settings.bulgarian": "ブルガリア語",
  "settings.catalan": "カタルーニャ語",
  "settings.chartGestures": "チャート上のジェスチャー",
  "settings.chartGesturesDescription": "チャートをスワイプすると期間が変更され、チャートをピンチすると時間スケールが変更されます",
  "settings.choiceCount": "{count, plural, other {# 件}}",
  "settings.contactUs": "お問い合わせ",
  "settings.contactUsDescription": "ヘルプまたはフィードバックを送信",
  "settings.croatian": "クロアチア語",
  "settings.czech": "チェコ語",
  "settings.dailyDetailByPeriods": "時間帯別の日別詳細",
  "settings.dailyDetailByPeriodsDescription": "24時間を夜・朝・午後・夕方にまとめます。日別サマリーと同じ区分です。",
  "settings.danish": "デンマーク語",
  "settings.dark": "ダークテーマ",
  "settings.dataDisplay": "データ表示",
  "settings.dateAndTime": "日時",
  "settings.donateButton": "寄付する",
  "settings.donateDescription": "SmartMixinは少人数のチームで開発しています。お役に立てているなら、任意の金額の一回限りの寄付で開発を応援できます。これは贈り物であり、プランの変更や機能のロック解除は行われません。",
  "settings.donateSuccessBody": "皆さまの寄付がSmartMixinの運営と改善を支えています。心より感謝いたします。",
  "settings.donateSuccessTitle": "ご支援ありがとうございます！",
  "settings.donateTitle": "SmartMixinを応援する",
  "settings.dragToReorder": "ドラッグして並べ替え",
  "settings.dutch": "オランダ語",
  "settings.english": "英語",
  "settings.french": "フランス語",
  "settings.german": "ドイツ語",
  "settings.gestures": "ジェスチャー",
  "settings.greek": "ギリシャ語",
  "settings.hungarian": "ハンガリー語",
  "settings.italian": "イタリア語",
  "settings.japanese": "日本語",
  "settings.korean": "韓国語",
  "settings.language": "言語",
  "settings.languageDescription": "優先言語",
  "settings.light": "ライトテーマ",
  "settings.mapTheme": "地図のテーマ",
  "settings.mapThemeAuto": "自動",
  "settings.mapThemeDark": "ダーク",
  "settings.mapThemeDescription": "自動にすると、地図はアプリのテーマに合わせます。",
  "settings.mapThemeLight": "ライト",
  "settings.measurementUnits": "測定単位",
  "settings.netatmoDashboard": "Netatmo ダッシュボード",
  "settings.netatmoLayoutCards": "カードリスト",
  "settings.netatmoLayoutCardsDescription": "モジュールごとに1枚のカード、1つのスクロールに",
  "settings.netatmoLayoutClassic": "クラシック",
  "settings.netatmoLayoutClassicDescription": "2枚のカード、モジュールを切り替え",
  "settings.netatmoNewLayoutNotice": "新しいレイアウト：モジュールごとに1枚のカード。",
  "settings.netatmoSwitchBackToClassic": "クラシックに戻す",
  "settings.netatmoSwitchToLayout": "{layout}に切り替え",
  "settings.norwegian": "ノルウェー語",
  "settings.notificationsSection": "通知",
  "settings.ongoingNotificationEnabled": "常駐通知を有効にする",
  "settings.ongoingNotificationMetrics": "表示する指標",
  "settings.ongoingNotificationPermissionRequired": "通知の許可が必要です",
  "settings.ongoingNotificationPreviewHint": "プレビュー — ウィジェットをオンにすると表示されます",
  "settings.ongoingNotificationStatusBar": "ステータスバー",
  "settings.polish": "ポーランド語",
  "settings.portuguese": "ポルトガル語",
  "settings.preferencesSection": "環境設定",
  "settings.privacyPolicy": "プライバシーポリシー",
  "settings.russian": "ロシア語",
  "settings.serbian": "セルビア語",
  "settings.settings": "設定",
  "settings.settingsPageTitle": "設定 - {page}",
  "settings.slovak": "スロバキア語",
  "settings.smallDecimals": "小数を小さく表示",
  "settings.smallDecimalsDescription": "小数点以下の数字を小さいサイズで表示",
  "settings.spanish": "スペイン語",
  "settings.statusBarWidget": "ステータスバーウィジェット",
  "settings.statusBarWidgetDescription": "常に表示される気象データ",
  "settings.subscriptionSection": "サブスクリプション",
  "settings.supportSection": "サポート",
  "settings.swedish": "スウェーデン語",
  "settings.systemTheme": "システムテーマ",
  "settings.termsOfService": "利用規約",
  "settings.themeDarkShort": "ダーク",
  "settings.themeLightShort": "ライト",
  "settings.themeSystemShort": "システム",
  "settings.turkish": "トルコ語",
  "settings.ukrainian": "ウクライナ語",
  "settings.units": "単位",
  "settings.unitsDescription": "アプリケーション内で表示される測定単位",
  "settings.update": "更新",
  "settings.windDirectionConvention": "風向矢印",
  "settings.windDirectionConventionDescription": "風向矢印の表示方法を選択",
  "settings.windDirectionMeteorological": "風上方向",
  "settings.windDirectionMeteorologicalDescription": "矢印は風の吹いてくる方向を示します（気象学の慣例）",
  "settings.windDirectionOceanographic": "風下方向",
  "settings.windDirectionOceanographicDescription": "矢印は風の吹いていく方向を示します（海洋学の慣例）",
  "stations.addAStation": "観測所を追加する",
  "stations.addToFavorites": "お気に入りに追加",
  "stations.addYourOwnStation": "自分の観測所を追加する",
  "stations.allowPreciseLocation": "正確な位置情報を許可",
  "stations.approximateLocationUnavailable": "おおよその位置情報を取得できません。タップして正確な位置情報を許可してください。",
  "stations.backToCurrentLocation": "現在の場所に戻る",
  "stations.backToPlace": "{place}に戻る",
  "stations.browserLocationUnavailable": "現在地を取得できませんでした。ブラウザがこのサイトに位置情報の使用を許可しているか確認してから、もう一度お試しください。",
  "stations.calculatedFor": "{time} 時点の計算値 · {model}",
  "stations.clearRecentLocations": "すべてクリア",
  "stations.currentLocation": "現在の場所",
  "stations.customizedStationName": "カスタマイズした観測所名",
  "stations.editMyWeather": "マイ天気を編集",
  "stations.favoriteLocations": "お気に入り",
  "stations.filterStations": "観測所の絞り込み",
  "stations.filterStationSourceDescription": "地図上に表示したい観測所プロバイダーを選択してください",
  "stations.findingYourLocation": "現在地を取得しています…",
  "stations.hiddenFromMyWeather": "{name}を非表示にしました",
  "stations.hiddenStations": "非表示の観測所",
  "stations.hiddenStationsDescription": "横にある目のアイコンをタップすると、観測所を再表示できます。",
  "stations.hideStationNamed": "{station}を非表示",
  "stations.lastSeen": "最終受信 {time}",
  "stations.loadingStation": "観測所を読み込んでいます…",
  "stations.location": "位置",
  "stations.locationAddedToFavorites": "場所をお気に入りに追加しました",
  "stations.locationNotGranted": "場所の許可は付与されていません。デバイス設定の場所へのアクセスを許可してください。",
  "stations.locationRemovedFromFavorites": "場所をお気に入りから削除しました",
  "stations.locations": "場所",
  "stations.locationUnavailable": "現在地を取得できませんでした。デバイスの設定を確認してください。",
  "stations.maxFavoriteLocationsReached": "お気に入りの場所は最大5件までです。別の場所を追加するには1件削除してください。",
  "stations.modifyFavoriteStations": "お気に入りの観測所を編集",
  "stations.modifyFavoriteStationsDescription": "お気に入りの観測所をドラッグして並べ替えることができます。リストから削除することもできます。",
  "stations.moreStationsFailed": "観測所の続きを読み込めませんでした",
  "stations.myLocation": "現在地",
  "stations.myStations": "マイ観測所",
  "stations.myWeather": "マイ天気",
  "stations.myWeatherIntroBody": "マイ観測所は引き続き一番上に表示されます。検索で地名と観測所の両方が見つかるようになりました。",
  "stations.myWeatherIntroOk": "OK",
  "stations.myWeatherIntroTitle": "観測所と場所が1つのリストに",
  "stations.myWeatherItemActions": "{name}の操作",
  "stations.nearbyWeatherStations": "近くの気象観測所",
  "stations.noLocationsFound": "場所が見つかりません",
  "stations.noLocationTitle": "どこの天気を表示しますか？",
  "stations.noLongerReported": "一覧に表示されなくなりました",
  "stations.noLongerReportedBy": "{date}以降、{provider}に表示されなくなりました",
  "stations.noPlaceFound": "場所が見つかりませんでした",
  "stations.noSearchResults": "検索に一致する記事がありません",
  "stations.noStationNamed": "「{query}」という名前の観測所はありません",
  "stations.noStationsFound": "観測所が見つかりません",
  "stations.noWeatherStationYet": "まだ気象観測所がありません。",
  "stations.places": "場所",
  "stations.placeSearchFailed": "場所を読み込めませんでした",
  "stations.recentLocations": "最近",
  "stations.removedFromMyWeather": "{name}を削除しました",
  "stations.removeFromFavorites": "お気に入りから削除",
  "stations.removeFromMyWeatherFailed": "{name}を削除できませんでした",
  "stations.removeStationNamed": "{station}をお気に入りから削除",
  "stations.reorderStationNamed": "{station}を移動",
  "stations.searchForLocation": "場所を検索",
  "stations.searchForWeatherStation": "気象観測所を検索する",
  "stations.searchPlaceOrStation": "場所または観測所を検索",
  "stations.searchResultsFound": "{count}件の結果が見つかりました",
  "stations.searchSummary": "場所 {places, plural, other {#件}}、観測所 {stations, plural, other {#件}}",
  "stations.searchTryAgain": "再試行",
  "stations.selectStationForComparison": "比較する観測所を選択してください",
  "stations.showAllStations": "すべて表示（{count}件）",
  "stations.shownInMyWeather": "{name}を再表示しました",
  "stations.stationAddedToFavorites": "観測所がお気に入りに追加されました",
  "stations.stationInformation": "観測所情報",
  "stations.stationName": "観測所名",
  "stations.stationObservationsDescription": "気象観測所からの最新の観測値を表示します",
  "stations.stationRemovedFromFavorites": "観測所がお気に入りから削除されました",
  "stations.stationSearchFailed": "観測所を読み込めませんでした",
  "stations.stationsLoading": "気象観測所を読み込み中",
  "stations.stationType": "観測所の種類",
  "stations.statusOffline": "オフライン",
  "stations.statusOnline": "オンライン",
  "stations.statusStale": "古い",
  "stations.undoRemove": "元に戻す",
  "stations.unhideStationNamed": "{station}を再表示",
  "stations.useMyLocation": "現在地を使用",
  "stations.weatherStation": "気象観測所",
  "stations.weatherStations": "気象観測所",
  "stations.welcomeConnectService": "気象観測所をお持ちですか？サービスを接続しましょう",
  "stations.welcomeSubtitle": "あなたの天気情報をひとつの場所に",
  "thermostat.away": "外出",
  "thermostat.boilerOn": "ボイラーON",
  "thermostat.hg": "凍結防止",
  "thermostat.homeInformation": "ホーム情報",
  "thermostat.homeName": "家の名前",
  "thermostat.manualBoost": "マニュアルブースト",
  "thermostat.manualSetpointUntil": "手動設定の終了日時",
  "thermostat.noThermostatYet": "あなたはまだサーモスタットを持っていません。",
  "thermostat.relay": "リレー",
  "thermostat.room": "部屋",
  "thermostat.roomAnticipating": "次の予定温度に向けて早めに暖房中",
  "thermostat.roomOpenWindow": "窓の開放を検知、暖房を一時停止中",
  "thermostat.rooms": "部屋",
  "thermostat.smartThermostat": "スマートサーモスタット",
  "thermostat.smartValve": "スマートバルブ",
  "thermostat.whenBackHome": "いつ家に帰りますか？",
  "units.celsius": "摂氏",
  "units.fahrenheit": "華氏",
  "units.inch": "インチ",
  "units.inchOfMercury": "水銀柱インチ",
  "units.kelvin": "ケルビン",
  "units.kilometerPerHour": "時速キロメートル",
  "units.knot": "ノット",
  "units.meterPerSecond": "メートル/秒",
  "units.milePerHour": "時速マイル",
  "units.millibar": "ミリバール",
  "units.millimeter": "ミリメートル",
  "units.millimeterOfMercury": "水銀柱ミリメートル",
  "weatherConditions.blizzard": "猛吹雪",
  "weatherConditions.blowingDust": "砂じん",
  "weatherConditions.blowingSnow": "地吹雪",
  "weatherConditions.breezy": "そよ風",
  "weatherConditions.clear": "快晴",
  "weatherConditions.cloudy": "曇り",
  "weatherConditions.drizzle": "霧雨",
  "weatherConditions.flurries": "小雪",
  "weatherConditions.foggy": "霧",
  "weatherConditions.freezingDrizzle": "着氷性の霧雨",
  "weatherConditions.freezingRain": "着氷性の雨",
  "weatherConditions.frigid": "厳寒",
  "weatherConditions.hail": "ひょう",
  "weatherConditions.haze": "煙霧",
  "weatherConditions.heavyRain": "大雨",
  "weatherConditions.heavySnow": "大雪",
  "weatherConditions.hot": "高温",
  "weatherConditions.hurricane": "ハリケーン",
  "weatherConditions.isolatedThunderstorms": "局地的な雷雨",
  "weatherConditions.mixedRainAndHail": "雨とひょう",
  "weatherConditions.mostlyClear": "おおむね晴れ",
  "weatherConditions.mostlyCloudy": "おおむね曇り",
  "weatherConditions.mostlySunny": "おおむね晴天",
  "weatherConditions.notAvailable": "気象状況を取得できません",
  "weatherConditions.partlyCloudy": "一部曇り",
  "weatherConditions.rain": "雨",
  "weatherConditions.rainSleet": "雨と凍雨",
  "weatherConditions.rainSnow": "みぞれ",
  "weatherConditions.scatteredShowers": "散発的なにわか雨",
  "weatherConditions.scatteredSnowShowers": "散発的なにわか雪",
  "weatherConditions.scatteredThunderstorms": "散発的な雷雨",
  "weatherConditions.showers": "にわか雨",
  "weatherConditions.sleet": "凍雨",
  "weatherConditions.smoke": "煙",
  "weatherConditions.snow": "雪",
  "weatherConditions.snowShowers": "にわか雪",
  "weatherConditions.strongStorms": "激しい雷雨",
  "weatherConditions.sunny": "晴れ",
  "weatherConditions.thunderstorms": "雷雨",
  "weatherConditions.tornado": "竜巻",
  "weatherConditions.tropicalStorm": "熱帯性暴風雨",
  "weatherConditions.windy": "強風",
  "weatherConditions.wintryMix": "冬季混合降水",
  "weatherMap.clusterMarkerName": "{metric} {value}、{count, plural, other {#}} か所の観測所の中央値、ズームイン",
  "weatherMap.legendHeavy": "強い",
  "weatherMap.legendLight": "弱い",
  "weatherMap.legendLightningHelp": "色は過去{minutes}分間の各落雷の経過時間を示します。新しいものは白、古いものは濃い赤で表示されます。",
  "weatherMap.legendNewest": "最新",
  "weatherMap.legendOldest": "最古",
  "weatherMap.legendStationsHelp": "マーカーの色は選択した指標の値を表します。",
  "weatherMap.lightningDataAttribution": "雷データ: Blitzortung.org",
  "weatherMap.lightningStrikes": "落雷",
  "weatherMap.lightningStrikesDescription": "リアルタイムの落雷を地図に表示",
  "weatherMap.mapLayers": "地図レイヤー",
  "weatherMap.mapLegend": "地図の凡例",
  "weatherMap.mapMode": "マップモード",
  "weatherMap.mapNameForecast": "予報マップ、{model}、{variable}",
  "weatherMap.mapNameObservations": "天気マップ、観測値",
  "weatherMap.modeForecast": "予報",
  "weatherMap.modeObservations": "観測値",
  "weatherMap.radarCardLabel": "雨レーダー（{time}）",
  "weatherMap.radarDataAttribution": "レーダーデータ: NOAA / EUMETNET OPERA / Radar-DPC via LibreWXR",
  "weatherMap.radarLoading": "雨レーダーを読み込んでいます",
  "weatherMap.radarTime": "レーダー時刻",
  "weatherMap.radarUnavailable": "レーダーを表示できません",
  "weatherMap.rainRadar": "雨レーダー",
  "weatherMap.rainRadarDescription": "地図上に雨レーダーをオーバーレイ表示します",
  "weatherMap.resetBearing": "ドラッグで地図を回転、クリックで北向きに戻す",
  "weatherMap.showingForecast": "表示中の予報: {model}、{variable}",
  "weatherMap.stationMarkerName": "{metric} {value}、観測所1か所",
  "weatherMap.stationMarkersHint": "矢印キーで観測所間を移動します",
  "weatherMap.stationMarkerWindValue": "{speed}、風向{direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain は、Nearcast Technology を活用した Tempest Weather System 経由で提供される追加のデータ ソースです。NC Rain データは、近隣レベルでの Tempest 周辺の平均降雨量の推定値です。",
  "weatherMap.weatherMap": "天気図",
  "weatherMap.weatherMapMetaDescription": "SmartMixinは世界中の気象状況に対応したインタラクティブな天気図とレーダーマップを提供します。",
  "weatherMap.zoomIn": "ズームイン",
  "weatherMap.zoomOut": "ズームアウト",
  "weatherWarnings.activeNow": "発表中",
  "weatherWarnings.agencyMessage": "気象機関からのメッセージ",
  "weatherWarnings.areaCovered": "対象地域",
  "weatherWarnings.areaThisLocation": "{area}（この地点）",
  "weatherWarnings.areaYourStation": "{area}（あなたの気象観測所）",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {公式警報、{severity}：{hazard}} other {公式警報、{severity}：{hazard}、ほか#件}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {今後の公式警報、{severity}：{hazard}} other {今後の公式警報、{severity}：{hazard}、ほか#件}}",
  "weatherWarnings.crumb": "公式の警報",
  "weatherWarnings.emptyBody": "国の気象機関がこの地点に発表している警報はありません。数分ごとに再確認します。",
  "weatherWarnings.emptyTitle": "公式の警報はありません",
  "weatherWarnings.ended": "終了",
  "weatherWarnings.endedAt": "この警報は{time}に終了しました。",
  "weatherWarnings.errorBody": "接続を確認してください。数分ごとに再試行します。",
  "weatherWarnings.errorTitle": "公式の警報を読み込めませんでした",
  "weatherWarnings.fromTime": "{time}から",
  "weatherWarnings.hazardAirQuality": "空気の質",
  "weatherWarnings.hazardAvalanche": "なだれ",
  "weatherWarnings.hazardCoastalEvent": "沿岸の危険",
  "weatherWarnings.hazardFlood": "洪水",
  "weatherWarnings.hazardFog": "霧",
  "weatherWarnings.hazardForestFire": "林野火災",
  "weatherWarnings.hazardHighTemperature": "高温",
  "weatherWarnings.hazardLowTemperature": "低温",
  "weatherWarnings.hazardOther": "その他の危険",
  "weatherWarnings.hazardRain": "雨",
  "weatherWarnings.hazardSnowIce": "雪・凍結",
  "weatherWarnings.hazardThunderstorm": "雷雨",
  "weatherWarnings.hazardUv": "紫外線",
  "weatherWarnings.hazardWind": "風",
  "weatherWarnings.hideHazards": "現象を非表示",
  "weatherWarnings.issuedBy": "発表元：{sender}",
  "weatherWarnings.lastUpdate": "最終更新: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {対象地域の地図：{area}。} other {対象の#地域の地図。{area}が強調表示されています。}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {対象地域の地図。} other {対象の#地域の地図。}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {地図を表示できません。対象地域は下に記載されています。} other {地図を表示できません。#地域は下に記載されています。}}",
  "weatherWarnings.moreHazards": "ほか{count}件：{hazards}",
  "weatherWarnings.notInLanguage": "{language}版はありません。気象機関が発表したとおりに表示しています。",
  "weatherWarnings.openOn": "{site}で開く",
  "weatherWarnings.otherAreas": "{count, plural, other {ほか#地域}}",
  "weatherWarnings.severityExtreme": "極めて重大",
  "weatherWarnings.severityFrom": "{time}から{severity}",
  "weatherWarnings.severityMinor": "軽度",
  "weatherWarnings.severityModerate": "中程度",
  "weatherWarnings.severityNow": "現在{severity}",
  "weatherWarnings.severitySevere": "重大",
  "weatherWarnings.severityUntil": "{time}まで{severity}",
  "weatherWarnings.showAllAreas": "{count, plural, other {#地域すべてを表示}}",
  "weatherWarnings.showAllOnMap": "{count, plural, other {地図に#地域すべてを表示}}",
  "weatherWarnings.showHazards": "現象を表示",
  "weatherWarnings.showPeriods": "{count, plural, other {#期間すべてを表示}}",
  "weatherWarnings.source": "出典: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}：{status}。",
  "weatherWarnings.spokenHazardTwo": "{hazard}：{first}、その後{second}。",
  "weatherWarnings.spokenLabel": "{count, plural, other {公式の気象警報 #件}}。{hazards}",
  "weatherWarnings.spokenLabelArea": "{label}{area}。",
  "weatherWarnings.spokenPeriod": "{severity}：{range}",
  "weatherWarnings.title": "公式の気象警報",
  "weatherWarnings.todayAt": "今日 {time}",
  "weatherWarnings.tomorrow": "明日",
  "weatherWarnings.tomorrowAt": "明日 {time}",
  "weatherWarnings.upcoming": "今後",
  "weatherWarnings.viewAll": "すべての公式警報",
  "weatherWarnings.whatToDo": "とるべき行動"
}
